(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7ff4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7ff4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("9pmxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d97edebbf63eb7a$export$2e2bcd8739ae039);

var $8OvKr = parcelRequire("8OvKr");

parcelRequire("irp73");
const $6d97edebbf63eb7a$var$SingleProduct = (section)=>{
    if (document.querySelector(".main-product-carousel")) {
        var options = {
            accessibility: true,
            prevNextButtons: true,
            pageDots: false,
            imagesLoaded: true
        };
        var navOptions = {
            asNavFor: ".main-product-carousel",
            draggable: false,
            groupCells: "100%",
            pageDots: false,
            prevNextButtons: false,
            cellAlign: "left"
        };
        var mainCarousel = document.querySelectorAll("[data-mainproductcarousel]");
        var productNavCarousel = document.querySelectorAll("[data-productNavCarousel]");
        mainCarousel.forEach((mainCarousel)=>new (0, (/*@__PURE__*/$parcel$interopDefault($8OvKr)))(mainCarousel, options));
        productNavCarousel.forEach((productNavCarousel)=>new (0, (/*@__PURE__*/$parcel$interopDefault($8OvKr)))(productNavCarousel, navOptions));
    }
};
var $6d97edebbf63eb7a$export$2e2bcd8739ae039 = $6d97edebbf63eb7a$var$SingleProduct;

});
parcelRegister("8OvKr", function(module, exports) {
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */ 







if (0, module.exports) {
    const Flickity = (parcelRequire("i59gD"));
    (parcelRequire("9MK0d"));
    (parcelRequire("kQq2F"));
    (parcelRequire("9jOQA"));
    (parcelRequire("dZUeJ"));
    (parcelRequire("ku1p2"));
    (parcelRequire("4xO1v"));
    (parcelRequire("6i5lX"));
    module.exports = Flickity;
}

});
parcelRegister("i59gD", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("hB7Ip")), (parcelRequire("iJtPS")), (parcelRequire("aMFvG")), (parcelRequire("3FUpo")), (parcelRequire("k3wIa")), (parcelRequire("u0iOH")));
    else {
        // browser global
        let _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(typeof window != "undefined" ? window : module.exports, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ // vars
    const { getComputedStyle: getComputedStyle, console: console } = window1;
    let { jQuery: jQuery } = window1;
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    let GUID = 0;
    // internal store of all Flickity intances
    let instances = {};
    function Flickity(element, options) {
        let queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error(`Bad element for Flickity: ${queryElement || element}`);
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            let instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = {
            ...this.constructor.defaults
        };
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: "center",
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.create = {};
    let proto = Flickity.prototype;
    // inherit EventEmitter
    Object.assign(proto, EvEmitter.prototype);
    proto._create = function() {
        let { resize: resize, watchCSS: watchCSS, rightToLeft: rightToLeft } = this.options;
        // add id for Flickity.data
        let id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.beginMargin = rightToLeft ? "marginRight" : "marginLeft";
        this.endMargin = rightToLeft ? "marginLeft" : "marginRight";
        // create viewport & slider
        this.viewport = document.createElement("div");
        this.viewport.className = "flickity-viewport";
        this._createSlider();
        // used for keyboard navigation
        this.focusableElems = [
            this.element
        ];
        if (resize || watchCSS) window1.addEventListener("resize", this);
        // add listeners from on option
        for(let eventName in this.options.on){
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        for(let method in Flickity.create)Flickity.create[method].call(this);
        if (watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        Object.assign(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add("flickity-enabled");
        if (this.options.rightToLeft) this.element.classList.add("flickity-rtl");
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        let cellElems = this._filterFindCellElements(this.element.children);
        this.slider.append(...cellElems);
        this.viewport.append(this.slider);
        this.element.append(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener("keydown", this);
        }
        this.emitEvent("activate");
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent("ready");
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        let slider = document.createElement("div");
        slider.className = "flickity-slider";
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        let cellElems = this._filterFindCellElements(elems);
        // create new Cells for collection
        return cellElems.map((cellElem)=>new Cell(cellElem));
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        let cellX = 0;
        // get cellX
        if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        this.cells.slice(index).forEach((cell)=>{
            cell.x = cellX;
            this._renderCellPosition(cell, cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        });
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    proto._renderCellPosition = function(cell, x) {
        // render position of cell with in slider
        let sideOffset = this.options.rightToLeft ? -1 : 1;
        let renderX = x * sideOffset;
        if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
        let positionValue = this.getPositionValue(renderX);
        cell.element.style.transform = `translateX( ${positionValue} )`;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach((cell)=>cell.getSize());
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        let { beginMargin: beginMargin, endMargin: endMargin } = this;
        let slide = new Slide(beginMargin, endMargin, this.cellAlign);
        this.slides.push(slide);
        let canCellFit = this._getCanCellFit();
        this.cells.forEach((cell, i)=>{
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            let slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
            if (canCellFit(i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(beginMargin, endMargin, this.cellAlign);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        });
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        let { groupCells: groupCells } = this.options;
        if (!groupCells) return ()=>false;
        if (typeof groupCells == "number") {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            let number = parseInt(groupCells, 10);
            return (i)=>i % number !== 0;
        }
        // default, group by width of slide
        let percent = 1;
        // parse '75%
        let percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
        if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
        let groupWidth = (this.size.innerWidth + 1) * percent;
        return (i, slideWidth)=>slideWidth <= groupWidth;
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    let cellAlignShorthands = {
        left: 0,
        center: 0.5,
        right: 1
    };
    proto.setCellAlign = function() {
        let { cellAlign: cellAlign, rightToLeft: rightToLeft } = this.options;
        let shorthand = cellAlignShorthands[cellAlign];
        this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
        if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
    };
    proto.setGallerySize = function() {
        if (!this.options.setGallerySize) return;
        let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = `${height}px`;
    };
    proto._updateWrapShiftCells = function() {
        // update isWrapping
        this.isWrapping = this.getIsWrapping();
        // only for wrap-around
        if (!this.isWrapping) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        let beforeGapX = this.cursorPosition;
        let lastIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        let afterGapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
    };
    proto.getIsWrapping = function() {
        let { wrapAround: wrapAround } = this.options;
        if (!wrapAround || this.slides.length < 2) return false;
        if (wrapAround !== "fill") return true;
        // check that slides can fit
        let gapWidth = this.slideableWidth - this.size.innerWidth;
        if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
        // check that content width - shifting cell is bigger than viewport width
        for (let cell of this.cells){
            if (cell.size.outerWidth > gapWidth) return false;
        }
        return true;
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        let cells = [];
        while(gapX > 0){
            let cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain & wrap ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
        if (!isContaining) return;
        let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
        // content is less than gallery size
        let isContentSmaller = contentWidth < this.size.innerWidth;
        if (isContentSmaller) // all cells fit inside gallery
        this.slides.forEach((slide)=>{
            slide.target = contentWidth * this.cellAlign;
        });
        else {
            // contain to bounds
            let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((slide)=>{
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            });
        }
    };
    // ----- events ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        let emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? ".flickity" : "";
            let $event = type;
            if (event) {
                // create jQuery event
                let jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    const unidraggerEvents = [
        "dragStart",
        "dragMove",
        "dragEnd",
        "pointerDown",
        "pointerMove",
        "pointerEnd",
        "staticClick"
    ];
    let _emitEvent = proto.emitEvent;
    proto.emitEvent = function(eventName, args) {
        if (eventName === "staticClick") {
            // add cellElem and cellIndex args to staticClick
            let clickedCell = this.getParentCell(args[0].target);
            let cellElem = clickedCell && clickedCell.element;
            let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
        }
        // do regular thing
        _emitEvent.call(this, eventName, args);
        // duck-punch in jQuery events for Unidragger events
        let isUnidraggerEvent = unidraggerEvents.includes(eventName);
        if (!isUnidraggerEvent || !jQuery || !this.$element) return;
        eventName += this.options.namespaceJQueryEvents ? ".flickity" : "";
        let event = args.shift(0);
        let jQEvent = new jQuery.Event(event);
        jQEvent.type = eventName;
        this.$element.trigger(jQEvent, args);
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.isWrapping || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        let prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent("select", null, [
            index
        ]);
        // change event if new index
        if (index !== prevIndex) this.dispatchEvent("change", null, [
            index
        ]);
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        if (!this.isWrapping) return;
        const { selectedIndex: selectedIndex, slideableWidth: slideableWidth, slides: { length: length } } = this;
        // shift index for wrap, do not wrap dragSelect
        if (!this.isDragSelect) {
            let wrapIndex = utils.modulo(index, length);
            // go to shortest
            let delta = Math.abs(wrapIndex - selectedIndex);
            let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) index += length;
            else if (forewardWrapDelta < delta) index -= length;
        }
        // wrap position so slider is within normal area
        if (index < 0) this.x -= slideableWidth;
        else if (index >= length) this.x += slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        let slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        let initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == "string") {
            let cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        let index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        let cell = this.queryCell(value);
        if (!cell) return;
        let index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slide that has cell
        let cellSlide = this.slides.find((slide)=>slide.cells.includes(cell));
        return this.slides.indexOf(cellSlide);
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for (let cell of this.cells){
            if (cell.element === elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        return elems.map((elem)=>this.getCell(elem)).filter(Boolean);
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        let cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        let closest = elem.closest(".flickity-slider > *");
        return this.getCell(closest);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        let len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements(); // get all
        let cellElems = [];
        for(let i = index - adjCount; i <= index + adjCount; i++){
            let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
            let slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == "number") // use number as index
        return this.cells[selector];
        // do not select invalid selectors from hash: #123, #/. #791
        let isSelectorString = typeof selector == "string" && !selector.match(/^[#.]?[\d/]/);
        if (isSelectorString) // use string as selector, get element
        selector = this.element.querySelector(selector);
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent("uiChange");
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, "onresize", 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.isWrapping) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
        this.emitEvent("resize");
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        let selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        if (!this.options.watchCSS) return;
        let afterContent = getComputedStyle(this.element, ":after").content;
        // activate if :after { content: 'flickity' }
        if (afterContent.includes("flickity")) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        let { activeElement: activeElement } = document;
        let handler = Flickity.keyboardHandlers[event.key];
        // only work if element is in focus
        if (!this.options.accessibility || !activeElement || !handler) return;
        let isFocused = this.focusableElems.some((elem)=>activeElement === elem);
        if (isFocused) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        ArrowLeft: function() {
            this.uiChange();
            let leftMethod = this.options.rightToLeft ? "next" : "previous";
            this[leftMethod]();
        },
        ArrowRight: function() {
            this.uiChange();
            let rightMethod = this.options.rightToLeft ? "previous" : "next";
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        this.element.focus({
            preventScroll: true
        });
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove("flickity-enabled");
        this.element.classList.remove("flickity-rtl");
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach((cell)=>cell.destroy());
        this.viewport.remove();
        // move child elements back into element
        this.element.append(...this.slider.children);
        if (this.options.accessibility) {
            this.element.removeAttribute("tabIndex");
            this.element.removeEventListener("keydown", this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent("deactivate");
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener("resize", this);
        this.allOff();
        this.emitEvent("destroy");
        if (jQuery && this.$element) jQuery.removeData(this.element, "flickity");
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    Object.assign(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        if (elem) return instances[elem.flickityGUID];
    };
    utils.htmlInit(Flickity, "flickity");
    let { jQueryBridget: jQueryBridget } = window1;
    if (jQuery && jQueryBridget) jQueryBridget("flickity", Flickity, jQuery);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("hB7Ip", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRegister("iJtPS", function(module, exports) {
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */ (function(window1, factory) {
    if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        let num = parseFloat(value);
        // not a percent like '100%', and a number
        let isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
    }
    // -------------------------- measurements -------------------------- //
    let measurements = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
    ];
    let measurementsLength = measurements.length;
    function getZeroSize() {
        let size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        measurements.forEach((measurement)=>{
            size[measurement] = 0;
        });
        return size;
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        // use querySeletor if elem is string
        if (typeof elem == "string") elem = document.querySelector(elem);
        // do not proceed on non-objects
        let isElement = elem && typeof elem == "object" && elem.nodeType;
        if (!isElement) return;
        let style = getComputedStyle(elem);
        // if hidden, everything is 0
        if (style.display == "none") return getZeroSize();
        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        let isBorderBox = size.isBorderBox = style.boxSizing == "border-box";
        // get all measurements
        measurements.forEach((measurement)=>{
            let value = style[measurement];
            let num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        });
        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;
        // overwrite width and height if we can get it from style
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingWidth + borderWidth);
        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("aMFvG", function(module, exports) {
/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(global);
    else // browser global
    global.fizzyUIUtils = factory(global);
})(module.exports, function factory(global) {
    let utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        return Object.assign(a, b);
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == "string") return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        return elems// check that elem is an actual element
        .filter((elem)=>elem instanceof HTMLElement).reduce((ffElems, elem)=>{
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return ffElems;
            }
            // filter & find items if we have a selector
            // filter
            if (elem.matches(selector)) ffElems.push(elem);
            // find children
            let childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            ffElems = ffElems.concat(...childElems);
            return ffElems;
        }, []);
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        let method = _class.prototype[methodName];
        let timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
            clearTimeout(this[timeoutName]);
            let args = arguments;
            this[timeoutName] = setTimeout(()=>{
                method.apply(this, args);
                delete this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(onDocReady);
        else document.addEventListener("DOMContentLoaded", onDocReady);
    };
    // ----- htmlInit ----- //
    // http://bit.ly/3oYLusc
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + "-" + $2;
        }).toLowerCase();
    };
    let console = global.console;
    // allow user to initialize classes via [data-namespace] or .js-namespace class
    // htmlInit( Widget, 'widgetName' )
    // options are parsed from data-namespace-options
    utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = "data-" + dashedNamespace;
            let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
            let jQuery = global.jQuery;
            [
                ...dataAttrElems
            ].forEach((elem)=>{
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
                    return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});

parcelRegister("3FUpo", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("iJtPS")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1.getSize);
    }
})(typeof window != "undefined" ? window : module.exports, function factory(getSize) {
    const cellClassName = "flickity-cell";
    function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
    }
    let proto = Cell.prototype;
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = "";
        this.element.removeAttribute("aria-hidden");
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.select = function() {
        this.element.classList.add("is-selected");
        this.element.removeAttribute("aria-hidden");
    };
    proto.unselect = function() {
        this.element.classList.remove("is-selected");
        this.element.setAttribute("aria-hidden", "true");
    };
    proto.remove = function() {
        this.element.remove();
    };
    return Cell;
});

});

parcelRegister("k3wIa", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(typeof window != "undefined" ? window : module.exports, function factory() {
    function Slide(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    let proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length === 1) {
            this.x = cell.x; // x comes from first cell
            this.firstMargin = cell.size[this.beginMargin];
        }
    };
    proto.updateTarget = function() {
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach((cell)=>cell.select());
    };
    proto.unselect = function() {
        this.cells.forEach((cell)=>cell.unselect());
    };
    proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    return Slide;
});

});

parcelRegister("u0iOH", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("aMFvG")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1.fizzyUIUtils);
    }
})(typeof window != "undefined" ? window : module.exports, function factory(utils) {
    // -------------------------- animate -------------------------- //
    let proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        let previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) requestAnimationFrame(()=>this.animate());
    };
    proto.positionSlider = function() {
        let x = this.x;
        // wrap position around
        if (this.isWrapping) {
            x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        if (this.options.rightToLeft) x = -x;
        let translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
    };
    proto.dispatchScrollEvent = function() {
        let firstSlide = this.slides[0];
        if (!firstSlide) return;
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent("scroll", null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + "%";
        else // pixel positioning
        return Math.round(position) + "px";
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent("settle", null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        let beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        cells.forEach((cell)=>{
            let cellShift = gap > 0 ? shift : 0;
            this._wrapShiftCell(cell, cellShift);
            gap -= cell.size.outerWidth;
        });
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        cells.forEach((cell)=>this._wrapShiftCell(cell, 0));
    };
    // @param {Integer} shift - 0, 1, or -1
    proto._wrapShiftCell = function(cell, shift) {
        this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("9MK0d", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("i59gD")), (parcelRequire("33EYW")), (parcelRequire("aMFvG")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(typeof window != "undefined" ? window : module.exports, function factory(window1, Flickity, Unidragger, utils) {
    // ----- defaults ----- //
    Object.assign(Flickity.defaults, {
        draggable: ">1",
        dragThreshold: 3
    });
    // -------------------------- drag prototype -------------------------- //
    let proto = Flickity.prototype;
    Object.assign(proto, Unidragger.prototype); // inherit Unidragger
    proto.touchActionValue = "";
    // --------------------------  -------------------------- //
    Flickity.create.drag = function() {
        this.on("activate", this.onActivateDrag);
        this.on("uiChange", this._uiChangeDrag);
        this.on("deactivate", this.onDeactivateDrag);
        this.on("cellChange", this.updateDraggable);
        this.on("pointerDown", this.handlePointerDown);
        this.on("pointerUp", this.handlePointerUp);
        this.on("pointerDown", this.handlePointerDone);
        this.on("dragStart", this.handleDragStart);
        this.on("dragMove", this.handleDragMove);
        this.on("dragEnd", this.handleDragEnd);
        this.on("staticClick", this.handleStaticClick);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove("is-draggable");
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable === ">1") this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        this.element.classList.toggle("is-draggable", this.isDraggable);
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.handlePointerDown = function(event) {
        if (!this.isDraggable) {
            // proceed for staticClick
            this.bindActivePointerEvents(event);
            return;
        }
        let isTouchStart = event.type === "touchstart";
        let isTouchPointer = event.pointerType === "touch";
        let isFocusNode = event.target.matches("input, textarea, select");
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
        if (!isFocusNode) this.focus();
        // blur
        if (document.activeElement !== this.element) document.activeElement.blur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add("is-pointer-down");
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener("scroll", this);
        this.bindActivePointerEvents(event);
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.handlePointerUp = function() {
        delete this.isTouchScrolling;
        this.viewport.classList.remove("is-pointer-down");
    };
    proto.handlePointerDone = function() {
        window1.removeEventListener("scroll", this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.handleDragStart = function() {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener("scroll", this);
    };
    proto.handleDragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        let direction = this.options.rightToLeft ? -1 : 1;
        // wrap around move. #589
        if (this.isWrapping) moveVector.x %= this.slideableWidth;
        let dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.isWrapping) {
            // slow drag
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
    };
    proto.handleDragEnd = function() {
        if (!this.isDraggable) return;
        let { freeScroll: freeScroll } = this.options;
        if (freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        let index = this.dragEndRestingSelect();
        if (freeScroll && !this.isWrapping) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!freeScroll && index === this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.isWrapping;
        this.select(index);
        delete this.isDragSelect;
    };
    proto.dragEndRestingSelect = function() {
        let restingX = this.getRestingPosition();
        // how far away from selected slide
        let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        let positiveResting = this._getClosestResting(restingX, distance, 1);
        let negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        let index = this.selectedIndex;
        let minDistance = Infinity;
        let condition = this.options.contain && !this.isWrapping ? // if containing, keep going if distance is equal to minDistance
        (dist, minDist)=>dist <= minDist : (dist, minDist)=>dist < minDist;
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        let len = this.slides.length;
        // wrap around if at least 2 slides
        let isWrapAround = this.options.wrapAround && len > 1;
        let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        let slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        let delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        let scroll = getScrollPosition();
        let scrollMoveX = this.pointerDownScroll.x - scroll.x;
        let scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this.pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("33EYW", function(module, exports) {

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */ (function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("4Y6EP")));
    else // browser global
    window1.Unidragger = factory(window1, window1.EvEmitter);
})(typeof window != "undefined" ? window : module.exports, function factory(window1, EvEmitter) {
    function Unidragger() {}
    // inherit EvEmitter
    let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
    // ----- bind start ----- //
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    let startEvent, activeEvents;
    if ("ontouchstart" in window1) {
        // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = "touchstart";
        activeEvents = [
            "touchmove",
            "touchend",
            "touchcancel"
        ];
    } else if (window1.PointerEvent) {
        // Pointer Events
        startEvent = "pointerdown";
        activeEvents = [
            "pointermove",
            "pointerup",
            "pointercancel"
        ];
    } else {
        // mouse events
        startEvent = "mousedown";
        activeEvents = [
            "mousemove",
            "mouseup"
        ];
    }
    // prototype so it can be overwriteable by Flickity
    proto.touchActionValue = "none";
    proto.bindHandles = function() {
        this._bindHandles("addEventListener", this.touchActionValue);
    };
    proto.unbindHandles = function() {
        this._bindHandles("removeEventListener", "");
    };
    /**
 * Add or remove start event
 * @param {String} bindMethod - addEventListener or removeEventListener
 * @param {String} touchAction - value for touch-action CSS property
 */ proto._bindHandles = function(bindMethod, touchAction) {
        this.handles.forEach((handle)=>{
            handle[bindMethod](startEvent, this);
            handle[bindMethod]("click", this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        });
    };
    proto.bindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.addEventListener(eventName, this);
        });
    };
    proto.unbindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.removeEventListener(eventName, this);
        });
    };
    // ----- event handler helpers ----- //
    // trigger method with matching pointer
    proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) this[methodName](event, event);
    };
    // trigger method with matching touch
    proto.withTouch = function(methodName, event) {
        let touch;
        for (let changedTouch of event.changedTouches)if (changedTouch.identifier === this.pointerIdentifier) touch = changedTouch;
        if (touch) this[methodName](event, touch);
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        this.pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
    };
    // nodes that have text fields
    const cursorNodes = [
        "TEXTAREA",
        "INPUT",
        "SELECT",
        "OPTION"
    ];
    // input types that do not have text fields
    const clickTypes = [
        "radio",
        "checkbox",
        "button",
        "submit",
        "image",
        "file"
    ];
    /**
 * any time you set `event, pointer` it refers to:
 * @param {Event} event
 * @param {Event | Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        // dismiss multi-touch taps, right clicks, and clicks on text fields
        let isCursorNode = cursorNodes.includes(event.target.nodeName);
        let isClickType = clickTypes.includes(event.target.type);
        let isOkayElement = !isCursorNode || isClickType;
        let isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        // track position for move
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent("pointerDown", [
            event,
            pointer
        ]);
    };
    // ----- move ----- //
    proto.onmousemove = function(event) {
        this.pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        this.withPointer("pointerMove", event);
    };
    proto.ontouchmove = function(event) {
        this.withTouch("pointerMove", event);
    };
    proto.pointerMove = function(event, pointer) {
        let moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent("pointerMove", [
            event,
            pointer,
            moveVector
        ]);
        // start drag if pointer has moved far enough to start drag
        let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- drag ----- //
    proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true; // set flag to prevent clicks
        this.emitEvent("dragStart", [
            event,
            pointer
        ]);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent("dragMove", [
            event,
            pointer,
            moveVector
        ]);
    };
    // ----- end ----- //
    proto.onmouseup = function(event) {
        this.pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        this.withPointer("pointerUp", event);
    };
    proto.ontouchend = function(event) {
        this.withTouch("pointerUp", event);
    };
    proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent("pointerUp", [
            event,
            pointer
        ]);
        if (this.isDragging) this.dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this.staticClick(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.isDragging = false; // reset flag
        // re-enable clicking async
        setTimeout(()=>delete this.isPreventingClicks);
        this.emitEvent("dragEnd", [
            event,
            pointer
        ]);
    };
    // triggered on pointer up & pointer cancel
    proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent("pointerDone");
    };
    // ----- cancel ----- //
    proto.onpointercancel = function(event) {
        this.withPointer("pointerCancel", event);
    };
    proto.ontouchcancel = function(event) {
        this.withTouch("pointerCancel", event);
    };
    proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent("pointerCancel", [
            event,
            pointer
        ]);
    };
    // ----- click ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // triggered after pointer down & up with no/tiny movement
    proto.staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        let isMouseup = event.type === "mouseup";
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent("staticClick", [
            event,
            pointer
        ]);
        // set flag for emulated clicks 300ms after touchend
        if (isMouseup) {
            this.isIgnoringMouseUp = true;
            // reset flag after 400ms
            setTimeout(()=>{
                delete this.isIgnoringMouseUp;
            }, 400);
        }
    };
    // -----  ----- //
    return Unidragger;
});

});
parcelRegister("4Y6EP", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});



parcelRegister("kQq2F", function(module, exports) {

// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("i59gD")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != "undefined" ? window : module.exports, function factory(Flickity) {
    const svgURI = "http://www.w3.org/2000/svg";
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === "previous";
        this.isLeft = direction === "left";
        this._create(arrowShape);
    }
    PrevNextButton.prototype._create = function(arrowShape) {
        // properties
        let element = this.element = document.createElement("button");
        element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let label = this.isPrevious ? "Previous" : "Next";
        // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
        element.setAttribute("type", "button");
        element.setAttribute("aria-label", label);
        // init as disabled
        this.disable();
        // create arrow
        let svg = this.createSVG(label, arrowShape);
        element.append(svg);
    };
    PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        let svg = document.createElementNS(svgURI, "svg");
        svg.setAttribute("class", "flickity-button-icon");
        svg.setAttribute("viewBox", "0 0 100 100");
        // add title #1189
        let title = document.createElementNS(svgURI, "title");
        title.append(label);
        // add path
        let path = document.createElementNS(svgURI, "path");
        let pathMovements = getArrowMovements(arrowShape);
        path.setAttribute("d", pathMovements);
        path.setAttribute("class", "arrow");
        // rotate arrow
        if (!this.isLeft) path.setAttribute("transform", "translate(100, 100) rotate(180)");
        svg.append(title, path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == "string") return shape;
        let { x0: x0, x1: x1, x2: x2, x3: x3, y1: y1, y2: y2 } = shape;
        // create movement string
        return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
    }
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute("disabled");
    };
    PrevNextButton.prototype.disable = function() {
        this.element.setAttribute("disabled", true);
    };
    // -------------------------- Flickity prototype -------------------------- //
    Object.assign(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let { rightToLeft: rightToLeft, arrowShape: arrowShape } = this.options;
        let prevDirection = rightToLeft ? "right" : "left";
        let nextDirection = rightToLeft ? "left" : "right";
        this.prevButton = new PrevNextButton("previous", prevDirection, arrowShape);
        this.nextButton = new PrevNextButton("next", nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = ()=>{
            this.uiChange();
            this.previous();
        };
        this.handleNextButtonClick = ()=>{
            this.uiChange();
            this.next();
        };
        this.on("activate", this.activatePrevNextButtons);
        this.on("select", this.updatePrevNextButtons);
    };
    let proto = Flickity.prototype;
    proto.updatePrevNextButtons = function() {
        let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
    };
    proto.updatePrevNextButton = function(button, disabledIndex) {
        // enable is wrapAround and at least 2 slides
        if (this.isWrapping && this.slides.length > 1) {
            button.enable();
            return;
        }
        let isEnabled = this.selectedIndex !== disabledIndex;
        button[isEnabled ? "enable" : "disable"]();
        // if disabling button that is focused,
        // shift focus to element to maintain keyboard accessibility
        let isDisabledFocused = !isEnabled && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener("click", this.handlePrevButtonClick);
        this.nextButton.element.addEventListener("click", this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on("deactivate", this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener("click", this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener("click", this.handleNextButtonClick);
        this.off("deactivate", this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("9jOQA", function(module, exports) {


// page dots
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("i59gD")), (parcelRequire("aMFvG")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != "undefined" ? window : module.exports, function factory(Flickity, utils) {
    // -------------------------- PageDots -------------------------- //
    function PageDots() {
        // create holder element
        this.holder = document.createElement("div");
        this.holder.className = "flickity-page-dots";
        // create dots, array of elements
        this.dots = [];
    }
    PageDots.prototype.setDots = function(slidesLength) {
        // get difference between number of slides and number of dots
        let delta = slidesLength - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        let newDots = new Array(count).fill().map((item, i)=>{
            let dot = document.createElement("button");
            dot.setAttribute("type", "button");
            let num = i + 1 + this.dots.length;
            dot.className = "flickity-page-dot";
            dot.textContent = `View slide ${num}`;
            return dot;
        });
        this.holder.append(...newDots);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        let removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach((dot)=>dot.remove());
    };
    PageDots.prototype.updateSelected = function(index) {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.classList.remove("is-selected");
            this.selectedDot.removeAttribute("aria-current");
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add("is-selected");
        this.selectedDot.setAttribute("aria-current", "step");
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pageDots: true
    });
    Flickity.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        // events
        this.on("activate", this.activatePageDots);
        this.on("select", this.updateSelectedPageDots);
        this.on("cellChange", this.updatePageDots);
        this.on("resize", this.updatePageDots);
        this.on("deactivate", this.deactivatePageDots);
    };
    let proto = Flickity.prototype;
    proto.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
        this.pageDots.holder.addEventListener("click", this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
    };
    proto.onPageDotsClick = function(event) {
        let index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return; // only dot clicks
        this.uiChange();
        this.select(index);
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
    };
    proto.updatePageDots = function() {
        this.pageDots.dots.forEach((dot)=>{
            utils.removeFrom(this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
    };
    proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener("click", this.handlePageDotsClick);
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("dZUeJ", function(module, exports) {

// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("i59gD")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != "undefined" ? window : module.exports, function factory(Flickity) {
    // -------------------------- Player -------------------------- //
    function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = "stopped";
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    // start play
    Player.prototype.play = function() {
        if (this.state === "playing") return;
        // do not play if page is hidden, start playing when page is visible
        let isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener("visibilitychange", this.onVisibilityPlay);
            return;
        }
        this.state = "playing";
        // listen to visibility change
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state !== "playing") return;
        // default to 3 seconds
        let time = typeof this.autoPlay == "number" ? this.autoPlay : 3000;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(()=>{
            this.onTick();
            this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = "stopped";
        this.clear();
        // remove visibility change event
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state === "playing") {
            this.state = "paused";
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state === "paused") this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        let isPageHidden = document.hidden;
        this[isPageHidden ? "pause" : "unpause"]();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener("visibilitychange", this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.create.player = function() {
        this.player = new Player(this.options.autoPlay, ()=>{
            this.next(true);
        });
        this.on("activate", this.activatePlayer);
        this.on("uiChange", this.stopPlayer);
        this.on("pointerDown", this.stopPlayer);
        this.on("deactivate", this.deactivatePlayer);
    };
    let proto = Flickity.prototype;
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener("mouseenter", this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener("mouseenter", this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener("mouseleave", this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener("mouseleave", this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("ku1p2", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("i59gD")), (parcelRequire("aMFvG")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != "undefined" ? window : module.exports, function factory(Flickity, utils) {
    // append cells to a document fragment
    function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach((cell)=>fragment.appendChild(cell.element));
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    let proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        let len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        let fragment = getCellsFragment(cells);
        // append to slider
        let isAppend = index === len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            let insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            let endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        let minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach((cell)=>{
            cell.remove();
            let index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        let cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        let index = this.cells.indexOf(cell);
        this.cellChange(index);
    // do not position slider after lazy load
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */ proto.cellChange = function(changedCellIndex) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex, try to maintain position & select previous selected element
        let cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent("cellChange", [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("4xO1v", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("i59gD")), (parcelRequire("aMFvG")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != "undefined" ? window : module.exports, function factory(Flickity, utils) {
    const lazyAttr = "data-flickity-lazyload";
    const lazySrcAttr = `${lazyAttr}-src`;
    const lazySrcsetAttr = `${lazyAttr}-srcset`;
    const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], ` + `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
    Flickity.create.lazyLoad = function() {
        this.on("select", this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
    };
    let proto = Flickity.prototype;
    proto.lazyLoad = function() {
        let { lazyLoad: lazyLoad } = this.options;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        let adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
        // lazy load images
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img)=>new LazyLoader(img, this.handleLazyLoadComplete));
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.matches("img")) {
            let cellAttr = cellElem.getAttribute(lazyAttr);
            let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
            let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
            if (cellAttr || cellSrcAttr || cellSrcsetAttr) return cellElem;
        }
        // select lazy images in cell
        return [
            ...cellElem.querySelectorAll(imgSelector)
        ];
    }
    proto.onLazyLoadComplete = function(img, event) {
        let cell = this.getParentCell(img);
        let cellElem = cell && cell.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent("lazyLoad", event, cellElem);
    };
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Function} onComplete - callback function
 */ function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        // get src & srcset
        let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        let srcset = this.img.getAttribute(lazySrcsetAttr);
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute("srcset", srcset);
        // remove attr
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, "flickity-lazyloaded");
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, "flickity-lazyerror");
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
        let mediaElem = this.img.parentNode.matches("picture") ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

parcelRegister("6i5lX", function(module, exports) {


// imagesloaded
(function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("i59gD")), (parcelRequire("bnMGW")));
    else // browser global
    factory(window1.Flickity, window1.imagesLoaded);
})(typeof window != "undefined" ? window : module.exports, function factory(Flickity, imagesLoaded) {
    Flickity.create.imagesLoaded = function() {
        this.on("activate", this.imagesLoaded);
    };
    Flickity.prototype.imagesLoaded = function() {
        if (!this.options.imagesLoaded) return;
        let onImagesLoadedProgress = (instance, image)=>{
            let cell = this.getParentCell(image.img);
            this.cellSizeChange(cell && cell.element);
            if (!this.options.freeScroll) this.positionSliderAtSelected();
        };
        imagesLoaded(this.slider).on("progress", onImagesLoadedProgress);
    };
    return Flickity;
});

});
parcelRegister("bnMGW", function(module, exports) {

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("5lgsj")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== "undefined" ? window : module.exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == "string") queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == "function") onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on("always", onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === "IMG") this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll("img");
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == "string") {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once("progress", onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent("progress", [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent("always", [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener("load", this);
        this.proxyImage.addEventListener("error", this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === "PICTURE" ? parentNode : this.img;
        this.emitEvent("progress", [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, "onload");
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, "onerror");
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this);
        this.proxyImage.removeEventListener("error", this);
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent("progress", [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});

});
parcelRegister("5lgsj", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});




parcelRegister("irp73", function(module, exports) {


/*!
 * Flickity asNavFor v3.0.0
 * enable asNavFor for Flickity
 */ (function(window1, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("8OvKr")), (parcelRequire("lbzh6")));
    else // browser global
    window1.Flickity = factory(window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(Flickity, utils) {
    // -------------------------- asNavFor prototype -------------------------- //
    // Flickity.defaults.asNavFor = null;
    Flickity.create.asNavFor = function() {
        this.on("activate", this.activateAsNavFor);
        this.on("deactivate", this.deactivateAsNavFor);
        this.on("destroy", this.destroyAsNavFor);
        let asNavForOption = this.options.asNavFor;
        if (!asNavForOption) return;
        // HACK do async, give time for other flickity to be initalized
        setTimeout(()=>{
            this.setNavCompanion(asNavForOption);
        });
    };
    let proto = Flickity.prototype;
    proto.setNavCompanion = function(elem) {
        elem = utils.getQueryElement(elem);
        let companion = Flickity.data(elem);
        // stop if no companion or companion is self
        if (!companion || companion === this) return;
        this.navCompanion = companion;
        // companion select
        this.onNavCompanionSelect = ()=>{
            this.navCompanionSelect();
        };
        companion.on("select", this.onNavCompanionSelect);
        // click
        this.on("staticClick", this.onNavStaticClick);
        this.navCompanionSelect(true);
    };
    proto.navCompanionSelect = function(isInstant) {
        // wait for companion & selectedCells first. #8
        let companionCells = this.navCompanion && this.navCompanion.selectedCells;
        if (!companionCells) return;
        // select slide that matches first cell of slide
        let selectedCell = companionCells[0];
        let firstIndex = this.navCompanion.cells.indexOf(selectedCell);
        let lastIndex = firstIndex + companionCells.length - 1;
        let selectIndex = Math.floor(lerp(firstIndex, lastIndex, this.navCompanion.cellAlign));
        this.selectCell(selectIndex, false, isInstant);
        // set nav selected class
        this.removeNavSelectedElements();
        // stop if companion has more cells than this one
        if (selectIndex >= this.cells.length) return;
        let selectedCells = this.cells.slice(firstIndex, lastIndex + 1);
        this.navSelectedElements = selectedCells.map((cell)=>cell.element);
        this.changeNavSelectedClass("add");
    };
    function lerp(a, b, t) {
        return (b - a) * t + a;
    }
    proto.changeNavSelectedClass = function(method) {
        this.navSelectedElements.forEach(function(navElem) {
            navElem.classList[method]("is-nav-selected");
        });
    };
    proto.activateAsNavFor = function() {
        this.navCompanionSelect(true);
    };
    proto.removeNavSelectedElements = function() {
        if (!this.navSelectedElements) return;
        this.changeNavSelectedClass("remove");
        delete this.navSelectedElements;
    };
    proto.onNavStaticClick = function(event, pointer, cellElement, cellIndex) {
        if (typeof cellIndex == "number") this.navCompanion.selectCell(cellIndex);
    };
    proto.deactivateAsNavFor = function() {
        this.removeNavSelectedElements();
    };
    proto.destroyAsNavFor = function() {
        if (!this.navCompanion) return;
        this.navCompanion.off("select", this.onNavCompanionSelect);
        this.off("staticClick", this.onNavStaticClick);
        delete this.navCompanion;
    };
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("lbzh6", function(module, exports) {
/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS
    module.exports = factory(global);
    else // browser global
    global.fizzyUIUtils = factory(global);
})(module.exports, function factory(global) {
    let utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        return Object.assign(a, b);
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == "string") return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        return elems// check that elem is an actual element
        .filter((elem)=>elem instanceof HTMLElement).reduce((ffElems, elem)=>{
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return ffElems;
            }
            // filter & find items if we have a selector
            // filter
            if (elem.matches(selector)) ffElems.push(elem);
            // find children
            let childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            ffElems = ffElems.concat(...childElems);
            return ffElems;
        }, []);
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        let method = _class.prototype[methodName];
        let timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
            clearTimeout(this[timeoutName]);
            let args = arguments;
            this[timeoutName] = setTimeout(()=>{
                method.apply(this, args);
                delete this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(onDocReady);
        else document.addEventListener("DOMContentLoaded", onDocReady);
    };
    // ----- htmlInit ----- //
    // http://bit.ly/3oYLusc
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + "-" + $2;
        }).toLowerCase();
    };
    let console = global.console;
    // allow user to initialize classes via [data-namespace] or .js-namespace class
    // htmlInit( Widget, 'widgetName' )
    // options are parsed from data-namespace-options
    utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = "data-" + dashedNamespace;
            let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
            let jQuery = global.jQuery;
            [
                ...dataAttrElems
            ].forEach((elem)=>{
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
                    return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});



parcelRegister("iqhLJ", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("2cw24")).then(()=>parcelRequire("3Gvgr"));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case "preload":
            return $55a6d16921f8ab25$var$cachedPreloads;
        case "prefetch":
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("ba3gM", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("5SWqN")).then(()=>parcelRequire("7GDqg"));

});

var $a9dad78bf84ee3e0$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("46bxV"), JSON.parse('["46bxV","main.js","2cw24","GalleryGrid.731443cf.js","5SWqN","bannerSlider.d9900c7d.js","jUeMg","main.css"]'));

const $dc2d63b917c60329$export$ebe90cb607ad99e = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease"
};

const $26fc349e92d9489e$export$2c9e8a9632a706b2 = (min, max, progress)=>-progress * min + progress * max + min;


const $a9ec4c6371c8c8ef$export$8793edee2d425525 = ()=>{};
const $a9ec4c6371c8c8ef$export$ea6e51872ab1b721 = (v)=>v;



const $b5fe3643ba3c2da8$export$504d7abb21fa8c9 = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);


function $9b3af257d77590ba$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $b5fe3643ba3c2da8$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $26fc349e92d9489e$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}
function $9b3af257d77590ba$export$24dbcec0b26e6d9d(length) {
    const offset = [
        0
    ];
    $9b3af257d77590ba$export$dafee61230cf05c6(offset, length - 1);
    return offset;
}



const $2600ec0fa268729d$export$7e4aa119212bc614 = (value)=>typeof value === "number";


const $0f92e8df025f9218$export$981cc9ef33696dc8 = (easing)=>Array.isArray(easing) && !(0, $2600ec0fa268729d$export$7e4aa119212bc614)(easing[0]);


const $50822229f89c800a$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};


function $e7e8fb4e721c4127$export$41c5e731255a462(easing, i) {
    return (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? easing[(0, $50822229f89c800a$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}


const $c39040460f3b0b9e$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


function $f9be231e4d7a00b5$export$89e29e4ab65e70a9(output, input = (0, $9b3af257d77590ba$export$24dbcec0b26e6d9d)(output.length), easing = (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721)) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */ const remainder = length - input.length;
    remainder > 0 && (0, $9b3af257d77590ba$export$dafee61230cf05c6)(input, remainder);
    return (t)=>{
        let i = 0;
        for(; i < length - 2; i++){
            if (t < input[i + 1]) break;
        }
        let progressInRange = (0, $c39040460f3b0b9e$export$7d15b64cf5a3a4c4)(0, 1, (0, $b5fe3643ba3c2da8$export$504d7abb21fa8c9)(input[i], input[i + 1], t));
        const segmentEasing = (0, $e7e8fb4e721c4127$export$41c5e731255a462)(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return (0, $26fc349e92d9489e$export$2c9e8a9632a706b2)(output[i], output[i + 1], progressInRange);
    };
}

const $c0efdae2be78a137$export$d81a3021299cadf2 = (easing)=>typeof easing === "object" && Boolean(easing.createAnimation);



/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $0c9f2a04764915a5$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $0c9f2a04764915a5$var$subdivisionPrecision = 0.0000001;
const $0c9f2a04764915a5$var$subdivisionMaxIterations = 12;
function $0c9f2a04764915a5$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $0c9f2a04764915a5$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $0c9f2a04764915a5$var$subdivisionPrecision && ++i < $0c9f2a04764915a5$var$subdivisionMaxIterations);
    return currentT;
}
function $0c9f2a04764915a5$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721;
    const getTForX = (aX)=>$0c9f2a04764915a5$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $0c9f2a04764915a5$var$calcBezier(getTForX(t), mY1, mY2);
}


const $fecf794dcc504830$export$be3f796aed065412 = (steps, direction = "end")=>(progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * steps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, $c39040460f3b0b9e$export$7d15b64cf5a3a4c4)(0, 1, rounded / steps);
    };



const $ead554a12e40dce0$export$77290801a62f77a2 = (easing)=>Array.isArray(easing) && (0, $2600ec0fa268729d$export$7e4aa119212bc614)(easing[0]);

const $6a6d195304e4357d$export$f6e2535fb5126e54 = (value)=>typeof value === "function";


const $feb0fd98b03164bf$var$namedEasings = {
    ease: (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(0.25, 0.1, 0.25, 1.0),
    "ease-in": (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(0.42, 0.0, 0.58, 1.0),
    "ease-out": (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(0.0, 0.0, 0.58, 1.0)
};
const $feb0fd98b03164bf$var$functionArgsRegex = /\((.*?)\)/;
function $feb0fd98b03164bf$export$9681b459c1c8f0f4(definition) {
    // If already an easing function, return
    if ((0, $6a6d195304e4357d$export$f6e2535fb5126e54)(definition)) return definition;
    // If an easing curve definition, return bezier function
    if ((0, $ead554a12e40dce0$export$77290801a62f77a2)(definition)) return (0, $0c9f2a04764915a5$export$2c575fa1d20488bd)(...definition);
    // If we have a predefined easing function, return
    if ($feb0fd98b03164bf$var$namedEasings[definition]) return $feb0fd98b03164bf$var$namedEasings[definition];
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = $feb0fd98b03164bf$var$functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return (0, $fecf794dcc504830$export$be3f796aed065412)(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return 0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721;
}


class $77d743c5fbee771c$export$c35d437ae5945fcd {
    constructor(output, keyframes = [
        0,
        1
    ], { easing: easing, duration: initialDuration = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).duration, delay: delay = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).repeat, offset: offset, direction: direction = "normal" } = {}){
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721);
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || (0, $dc2d63b917c60329$export$ebe90cb607ad99e).easing;
        if ((0, $c0efdae2be78a137$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721) : (0, $feb0fd98b03164bf$export$9681b459c1c8f0f4)(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = (0, $f9be231e4d7a00b5$export$89e29e4ab65e70a9)(keyframes, offset, (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? easing.map((0, $feb0fd98b03164bf$export$9681b459c1c8f0f4)) : (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721));
        this.tick = (timestamp)=>{
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay;
            let t = 0;
            if (this.pauseTime !== undefined) t = this.pauseTime;
            else t = (timestamp - this.startTime) * this.rate;
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */ if (this.playState === "finished" && this.pauseTime === undefined) t = this.totalDuration;
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) iterationProgress = 1;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) iterationProgress = 1 - iterationProgress;
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined && (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 || _a.call(this, latest);
            } else if (this.playState !== "idle") this.frameRequestId = requestAnimationFrame(this.tick);
        };
        this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) this.startTime = now - this.pauseTime;
        else if (!this.startTime) this.startTime = now;
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) cancelAnimationFrame(this.frameRequestId);
        (_a = this.reject) === null || _a === void 0 || _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() {}
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) this.pauseTime = t;
        else this.startTime = performance.now() - t / this.rate;
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}


var $82adf2b309a976d9$export$491112666e282270 = function() {};
var $82adf2b309a976d9$export$f5708dca728d7177 = function() {};


/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */ class $091e5423bab70e58$export$8cea36d14ee64562 {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 || animation.finished.then(()=>this.clearAnimation()).catch(()=>{});
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}


const $4ac2d59feaf07851$var$data = new WeakMap();
function $4ac2d59feaf07851$export$213eea93596b44f(element) {
    if (!$4ac2d59feaf07851$var$data.has(element)) $4ac2d59feaf07851$var$data.set(element, {
        transforms: [],
        values: new Map()
    });
    return $4ac2d59feaf07851$var$data.get(element);
}
function $4ac2d59feaf07851$export$c0999ba824977ca6(motionValues, name) {
    if (!motionValues.has(name)) motionValues.set(name, new (0, $091e5423bab70e58$export$8cea36d14ee64562)());
    return motionValues.get(name);
}


function $2bf1343b4ac164eb$export$20e507e47fae79fd(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function $2bf1343b4ac164eb$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}



/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ const $4be6463a6552f378$export$a9a762b9618d4a18 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ const $4be6463a6552f378$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
const $4be6463a6552f378$export$97b5d3c90609c212 = {
    x: "translateX",
    y: "translateY",
    z: "translateZ"
};
const $4be6463a6552f378$var$rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v)=>v + "deg"
};
const $4be6463a6552f378$var$baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v)=>v + "px"
    },
    rotate: $4be6463a6552f378$var$rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721)
    },
    skew: $4be6463a6552f378$var$rotation
};
const $4be6463a6552f378$export$a9dad2abc3d443d = new Map();
const $4be6463a6552f378$export$7bbd29b1fa8b68d4 = (name)=>`--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */ const $4be6463a6552f378$var$transforms = [
    "x",
    "y",
    "z"
];
$4be6463a6552f378$var$order.forEach((name)=>{
    $4be6463a6552f378$export$a9a762b9618d4a18.forEach((axis)=>{
        $4be6463a6552f378$var$transforms.push(name + axis);
        $4be6463a6552f378$export$a9dad2abc3d443d.set($4be6463a6552f378$export$7bbd29b1fa8b68d4(name + axis), $4be6463a6552f378$var$baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ const $4be6463a6552f378$export$11410fe03e8c4042 = (a, b)=>$4be6463a6552f378$var$transforms.indexOf(a) - $4be6463a6552f378$var$transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */ const $4be6463a6552f378$var$transformLookup = new Set($4be6463a6552f378$var$transforms);
const $4be6463a6552f378$export$8a546e9da811625d = (name)=>$4be6463a6552f378$var$transformLookup.has(name);
const $4be6463a6552f378$export$40eba1f1af915c93 = (element, name)=>{
    // Map x to translateX etc
    if ($4be6463a6552f378$export$97b5d3c90609c212[name]) name = $4be6463a6552f378$export$97b5d3c90609c212[name];
    const { transforms: transforms } = (0, $4ac2d59feaf07851$export$213eea93596b44f)(element);
    (0, $2bf1343b4ac164eb$export$20e507e47fae79fd)(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */ element.style.transform = $4be6463a6552f378$export$785216816cb6f870(transforms);
};
const $4be6463a6552f378$export$785216816cb6f870 = (transforms)=>transforms.sort($4be6463a6552f378$export$11410fe03e8c4042).reduce($4be6463a6552f378$var$transformListToString, "").trim();
const $4be6463a6552f378$var$transformListToString = (template, name)=>`${template} ${name}(var(${$4be6463a6552f378$export$7bbd29b1fa8b68d4(name)}))`;


const $ccd27e317ff74620$export$30a9abfd5fb9f5f6 = (name)=>name.startsWith("--");
const $ccd27e317ff74620$export$7a740cb9e3dd106d = new Set();
function $ccd27e317ff74620$export$9fdd8c2f6f59adb0(name) {
    if ($ccd27e317ff74620$export$7a740cb9e3dd106d.has(name)) return;
    $ccd27e317ff74620$export$7a740cb9e3dd106d.add(name);
    try {
        const { syntax: syntax, initialValue: initialValue } = (0, $4be6463a6552f378$export$a9dad2abc3d443d).has(name) ? (0, $4be6463a6552f378$export$a9dad2abc3d443d).get(name) : {};
        CSS.registerProperty({
            name: name,
            inherits: false,
            syntax: syntax,
            initialValue: initialValue
        });
    } catch (e) {}
}


const $b41dbcd6c6617a69$export$2da9be4cfdb689b1 = {
    ms: (seconds)=>seconds * 1000,
    s: (milliseconds)=>milliseconds / 1000
};




const $15b73f7aeef5597f$var$testAnimation = (keyframes, options)=>document.createElement("div").animate(keyframes, options);
const $15b73f7aeef5597f$var$featureTests = {
    cssRegisterProperty: ()=>typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: ()=>{
        try {
            $15b73f7aeef5597f$var$testAnimation({
                opacity: [
                    1
                ]
            });
        } catch (e) {
            return false;
        }
        return true;
    },
    finished: ()=>Boolean($15b73f7aeef5597f$var$testAnimation({
            opacity: [
                0,
                1
            ]
        }, {
            duration: 0.001
        }).finished),
    linearEasing: ()=>{
        try {
            $15b73f7aeef5597f$var$testAnimation({
                opacity: 0
            }, {
                easing: "linear(0, 1)"
            });
        } catch (e) {
            return false;
        }
        return true;
    }
};
const $15b73f7aeef5597f$var$results = {};
const $15b73f7aeef5597f$export$cde6a56f9669daf6 = {};
for(const key in $15b73f7aeef5597f$var$featureTests)$15b73f7aeef5597f$export$cde6a56f9669daf6[key] = ()=>{
    if ($15b73f7aeef5597f$var$results[key] === undefined) $15b73f7aeef5597f$var$results[key] = $15b73f7aeef5597f$var$featureTests[key]();
    return $15b73f7aeef5597f$var$results[key];
};


// Create a linear easing point for every x second
const $b177fba31032c2b0$var$resolution = 0.015;
const $b177fba31032c2b0$export$a74bbb7e96c8ced4 = (easing, duration)=>{
    let points = "";
    const numPoints = Math.round(duration / $b177fba31032c2b0$var$resolution);
    for(let i = 0; i < numPoints; i++)points += easing((0, $b5fe3643ba3c2da8$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return points.substring(0, points.length - 2);
};
const $b177fba31032c2b0$export$284d1118c33f9836 = (easing, duration)=>{
    if ((0, $6a6d195304e4357d$export$f6e2535fb5126e54)(easing)) return (0, $15b73f7aeef5597f$export$cde6a56f9669daf6).linearEasing() ? `linear(${$b177fba31032c2b0$export$a74bbb7e96c8ced4(easing, duration)})` : (0, $dc2d63b917c60329$export$ebe90cb607ad99e).easing;
    else return (0, $ead554a12e40dce0$export$77290801a62f77a2)(easing) ? $b177fba31032c2b0$export$2523b8f0bd8f44cb(easing) : easing;
};
const $b177fba31032c2b0$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



function $330ddc5eb9100e1b$export$3d2f5b3e7004e0cf(keyframes, readInitialValue) {
    for(let i = 0; i < keyframes.length; i++)if (keyframes[i] === null) keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    return keyframes;
}
const $330ddc5eb9100e1b$export$388e66a97327a012 = (keyframes)=>Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];




function $14b715416518df98$export$b6557f397a74f857(key) {
    if ((0, $4be6463a6552f378$export$97b5d3c90609c212)[key]) key = (0, $4be6463a6552f378$export$97b5d3c90609c212)[key];
    return (0, $4be6463a6552f378$export$8a546e9da811625d)(key) ? (0, $4be6463a6552f378$export$7bbd29b1fa8b68d4)(key) : key;
}



const $c78e3a46d208c382$export$1d567c320f4763bc = {
    get: (element, name)=>{
        name = (0, $14b715416518df98$export$b6557f397a74f857)(name);
        let value = (0, $ccd27e317ff74620$export$30a9abfd5fb9f5f6)(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
        if (!value && value !== 0) {
            const definition = (0, $4be6463a6552f378$export$a9dad2abc3d443d).get(name);
            if (definition) value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value)=>{
        name = (0, $14b715416518df98$export$b6557f397a74f857)(name);
        if ((0, $ccd27e317ff74620$export$30a9abfd5fb9f5f6)(name)) element.style.setProperty(name, value);
        else element.style[name] = value;
    }
};



function $2b08528401504e63$export$3cc6f911ef1fd837(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished") return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) animation.stop();
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    } catch (e) {}
}


const $1ec475b080df4cc4$export$844ec244b1367d54 = (value)=>typeof value === "string";


function $bf7f460c325e3a7a$export$4bcf070800a2fd35(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || (0, $a9ec4c6371c8c8ef$export$ea6e51872ab1b721);
    const finalKeyframe = keyframes[keyframes.length - 1];
    if ((0, $1ec475b080df4cc4$export$844ec244b1367d54)(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit) toUnit = (value)=>value + unit;
    }
    return toUnit;
}


function $9ef3fcdee5d7d99d$var$getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function $9ef3fcdee5d7d99d$export$c76cd972d26986f9(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = $9ef3fcdee5d7d99d$var$getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration: duration = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).duration, delay: delay = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).delay, endDelay: endDelay = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).endDelay, repeat: repeat = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).repeat, easing: easing = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).easing, persist: persist = false, direction: direction, offset: offset, allowWebkitAcceleration: allowWebkitAcceleration = false } = options;
    const data = (0, $4ac2d59feaf07851$export$213eea93596b44f)(element);
    const valueIsTransform = (0, $4be6463a6552f378$export$8a546e9da811625d)(key);
    let canAnimateNatively = (0, $15b73f7aeef5597f$export$cde6a56f9669daf6).waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */ valueIsTransform && (0, $4be6463a6552f378$export$40eba1f1af915c93)(element, key);
    const name = (0, $14b715416518df98$export$b6557f397a74f857)(key);
    const motionValue = (0, $4ac2d59feaf07851$export$c0999ba824977ca6)(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */ const definition = (0, $4be6463a6552f378$export$a9dad2abc3d443d).get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */ (0, $2b08528401504e63$export$3cc6f911ef1fd837)(motionValue.animation, !((0, $c0efdae2be78a137$export$d81a3021299cadf2)(easing) && motionValue.generator) && options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */ return ()=>{
        const readInitialValue = ()=>{
            var _a, _b;
            return (_b = (_a = (0, $c78e3a46d208c382$export$1d567c320f4763bc).get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
        };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */ let keyframes = (0, $330ddc5eb9100e1b$export$3d2f5b3e7004e0cf)((0, $330ddc5eb9100e1b$export$388e66a97327a012)(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */ const toUnit = (0, $bf7f460c325e3a7a$export$4bcf070800a2fd35)(keyframes, definition);
        if ((0, $c0efdae2be78a137$export$d81a3021299cadf2)(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */ if ((0, $ccd27e317ff74620$export$30a9abfd5fb9f5f6)(name)) {
            if ((0, $15b73f7aeef5597f$export$cde6a56f9669daf6).cssRegisterProperty()) (0, $ccd27e317ff74620$export$9fdd8c2f6f59adb0)(name);
            else canAnimateNatively = false;
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */ if (valueIsTransform && !(0, $15b73f7aeef5597f$export$cde6a56f9669daf6).linearEasing() && ((0, $6a6d195304e4357d$export$f6e2535fb5126e54)(easing) || (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) && easing.some((0, $6a6d195304e4357d$export$f6e2535fb5126e54)))) canAnimateNatively = false;
        /**
         * If we can animate this value with WAAPI, do so.
         */ if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */ if (definition) keyframes = keyframes.map((value)=>(0, $2600ec0fa268729d$export$7e4aa119212bc614)(value) ? definition.toDefaultUnit(value) : value);
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */ if (keyframes.length === 1 && (!(0, $15b73f7aeef5597f$export$cde6a56f9669daf6).partialKeyframes() || isRecording)) keyframes.unshift(readInitialValue());
            const animationOptions = {
                delay: (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).ms(delay),
                duration: (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).ms(duration),
                endDelay: (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).ms(endDelay),
                easing: !(0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? (0, $b177fba31032c2b0$export$284d1118c33f9836)(easing, duration) : undefined,
                direction: direction,
                iterations: repeat + 1,
                fill: "both"
            };
            animation = element.animate({
                [name]: keyframes,
                offset: offset,
                easing: (0, $0f92e8df025f9218$export$981cc9ef33696dc8)(easing) ? easing.map((thisEasing)=>(0, $b177fba31032c2b0$export$284d1118c33f9836)(thisEasing, duration)) : undefined
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */ if (!animation.finished) animation.finished = new Promise((resolve, reject)=>{
                animation.onfinish = resolve;
                animation.oncancel = reject;
            });
            const target = keyframes[keyframes.length - 1];
            animation.finished.then(()=>{
                if (persist) return;
                // Apply styles to target
                (0, $c78e3a46d208c382$export$1d567c320f4763bc).set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            }).catch((0, $a9ec4c6371c8c8ef$export$8793edee2d425525));
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */ if (!allowWebkitAcceleration) animation.playbackRate = 1.000001;
        /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */ } else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */ keyframes = keyframes.map((value)=>typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */ if (keyframes.length === 1) keyframes.unshift(parseFloat(readInitialValue()));
            animation = new AnimationPolyfill((latest)=>{
                (0, $c78e3a46d208c382$export$1d567c320f4763bc).set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), {
                duration: duration,
                easing: easing
            }));
        } else {
            const target = keyframes[keyframes.length - 1];
            (0, $c78e3a46d208c382$export$1d567c320f4763bc).set(element, name, definition && (0, $2600ec0fa268729d$export$7e4aa119212bc614)(target) ? definition.toDefaultUnit(target) : target);
        }
        if (isRecording) record(element, key, keyframes, {
            duration: duration,
            delay: delay,
            easing: easing,
            repeat: repeat,
            offset: offset
        }, "motion-one");
        motionValue.setAnimation(animation);
        return animation;
    };
}


const $57d7e8b2ef7ce651$export$d2312e68e1f5ad00 = (options, key)=>/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */ options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);


function $b9a28f0b498c113a$export$90ceba2564a894f8(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = document.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}




const $ff34fe8b644280e4$var$createAnimation = (factory)=>factory();
const $ff34fe8b644280e4$export$c5e4bb50450218c1 = (animationFactory, options, duration = (0, $dc2d63b917c60329$export$ebe90cb607ad99e).duration)=>{
    return new Proxy({
        animations: animationFactory.map($ff34fe8b644280e4$var$createAnimation).filter(Boolean),
        duration: duration,
        options: options
    }, $ff34fe8b644280e4$export$cc1adf6fb659c762);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */ const $ff34fe8b644280e4$var$getActiveAnimation = (state)=>state.animations[0];
const $ff34fe8b644280e4$export$cc1adf6fb659c762 = {
    get: (target, key)=>{
        const activeAnimation = $ff34fe8b644280e4$var$getActiveAnimation(target);
        switch(key){
            case "duration":
                return target.duration;
            case "currentTime":
                return (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) target.finished = Promise.all(target.animations.map($ff34fe8b644280e4$var$selectFinished)).catch((0, $a9ec4c6371c8c8ef$export$8793edee2d425525));
                return target.finished;
            case "stop":
                return ()=>{
                    target.animations.forEach((animation)=>(0, $2b08528401504e63$export$3cc6f911ef1fd837)(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */ return (callback)=>{
                    target.animations.forEach((animation)=>callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? undefined : ()=>target.animations.forEach((animation)=>animation[key]());
        }
    },
    set: (target, key, value)=>{
        switch(key){
            case "currentTime":
                value = (0, $b41dbcd6c6617a69$export$2da9be4cfdb689b1).ms(value);
            case "currentTime":
            case "playbackRate":
                for(let i = 0; i < target.animations.length; i++)target.animations[i][key] = value;
                return true;
        }
        return false;
    }
};
const $ff34fe8b644280e4$var$selectFinished = (animation)=>animation.finished;




function $98bb634993f4306d$export$ef0b4d89074db4d0(duration = 0.1, { start: start = 0, from: from = 0, easing: easing } = {}) {
    return (i, total)=>{
        const fromIndex = (0, $2600ec0fa268729d$export$7e4aa119212bc614)(from) ? from : $98bb634993f4306d$export$a7952f4918e96441(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = (0, $feb0fd98b03164bf$export$9681b459c1c8f0f4)(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function $98bb634993f4306d$export$a7952f4918e96441(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $98bb634993f4306d$export$4cf8f03b86be8175(option, i, total) {
    return (0, $6a6d195304e4357d$export$f6e2535fb5126e54)(option) ? option(i, total) : option;
}


function $e9a68bb46f2fff46$export$2a47ca22dbf0bb08(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = (0, $b9a28f0b498c113a$export$90ceba2564a894f8)(elements);
        const numElements = elements.length;
        (0, $82adf2b309a976d9$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
        (0, $82adf2b309a976d9$export$f5708dca728d7177)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */ const animationFactories = [];
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            for(const key in keyframes){
                const valueOptions = (0, $57d7e8b2ef7ce651$export$d2312e68e1f5ad00)(options, key);
                valueOptions.delay = (0, $98bb634993f4306d$export$4cf8f03b86be8175)(valueOptions.delay, i, numElements);
                const animation = (0, $9ef3fcdee5d7d99d$export$c76cd972d26986f9)(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return (0, $ff34fe8b644280e4$export$c5e4bb50450218c1)(animationFactories, options, /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */ options.duration);
    };
}


const $8c32d4e44fcce1d2$export$e3607ec2d7a891c4 = (0, $e9a68bb46f2fff46$export$2a47ca22dbf0bb08)((0, $77d743c5fbee771c$export$c35d437ae5945fcd));




function $e7dee9a46833b703$export$290670472807ab5b(target, options = {}) {
    return (0, $ff34fe8b644280e4$export$c5e4bb50450218c1)([
        ()=>{
            const animation = new (0, $77d743c5fbee771c$export$c35d437ae5945fcd)(target, [
                0,
                1
            ], options);
            animation.finished.catch(()=>{});
            return animation;
        }
    ], options, options.duration);
}
function $e7dee9a46833b703$export$e3607ec2d7a891c4(target, keyframesOrOptions, options) {
    const factory = (0, $6a6d195304e4357d$export$f6e2535fb5126e54)(target) ? $e7dee9a46833b703$export$290670472807ab5b : (0, $8c32d4e44fcce1d2$export$e3607ec2d7a891c4);
    return factory(target, keyframesOrOptions, options);
}



const $983dfce98d47352b$var$thresholds = {
    any: 0,
    all: 1
};
function $983dfce98d47352b$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */ if (typeof IntersectionObserver === "undefined") return ()=>{};
    const elements = (0, $b9a28f0b498c113a$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if ((0, $6a6d195304e4357d$export$f6e2535fb5126e54)(newOnEnd)) activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $983dfce98d47352b$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}


// packages/alpinejs/src/scheduler.js
var $f347e48613385d9c$var$flushPending = false;
var $f347e48613385d9c$var$flushing = false;
var $f347e48613385d9c$var$queue = [];
var $f347e48613385d9c$var$lastFlushedIndex = -1;
function $f347e48613385d9c$var$scheduler(callback) {
    $f347e48613385d9c$var$queueJob(callback);
}
function $f347e48613385d9c$var$queueJob(job) {
    if (!$f347e48613385d9c$var$queue.includes(job)) $f347e48613385d9c$var$queue.push(job);
    $f347e48613385d9c$var$queueFlush();
}
function $f347e48613385d9c$var$dequeueJob(job) {
    let index = $f347e48613385d9c$var$queue.indexOf(job);
    if (index !== -1 && index > $f347e48613385d9c$var$lastFlushedIndex) $f347e48613385d9c$var$queue.splice(index, 1);
}
function $f347e48613385d9c$var$queueFlush() {
    if (!$f347e48613385d9c$var$flushing && !$f347e48613385d9c$var$flushPending) {
        $f347e48613385d9c$var$flushPending = true;
        queueMicrotask($f347e48613385d9c$var$flushJobs);
    }
}
function $f347e48613385d9c$var$flushJobs() {
    $f347e48613385d9c$var$flushPending = false;
    $f347e48613385d9c$var$flushing = true;
    for(let i = 0; i < $f347e48613385d9c$var$queue.length; i++){
        $f347e48613385d9c$var$queue[i]();
        $f347e48613385d9c$var$lastFlushedIndex = i;
    }
    $f347e48613385d9c$var$queue.length = 0;
    $f347e48613385d9c$var$lastFlushedIndex = -1;
    $f347e48613385d9c$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f347e48613385d9c$var$reactive;
var $f347e48613385d9c$var$effect;
var $f347e48613385d9c$var$release;
var $f347e48613385d9c$var$raw;
var $f347e48613385d9c$var$shouldSchedule = true;
function $f347e48613385d9c$var$disableEffectScheduling(callback) {
    $f347e48613385d9c$var$shouldSchedule = false;
    callback();
    $f347e48613385d9c$var$shouldSchedule = true;
}
function $f347e48613385d9c$var$setReactivityEngine(engine) {
    $f347e48613385d9c$var$reactive = engine.reactive;
    $f347e48613385d9c$var$release = engine.release;
    $f347e48613385d9c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f347e48613385d9c$var$shouldSchedule) $f347e48613385d9c$var$scheduler(task);
                else task();
            }
        });
    $f347e48613385d9c$var$raw = engine.raw;
}
function $f347e48613385d9c$var$overrideEffect(override) {
    $f347e48613385d9c$var$effect = override;
}
function $f347e48613385d9c$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f347e48613385d9c$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f347e48613385d9c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/mutation.js
var $f347e48613385d9c$var$onAttributeAddeds = [];
var $f347e48613385d9c$var$onElRemoveds = [];
var $f347e48613385d9c$var$onElAddeds = [];
function $f347e48613385d9c$var$onElAdded(callback) {
    $f347e48613385d9c$var$onElAddeds.push(callback);
}
function $f347e48613385d9c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f347e48613385d9c$var$onElRemoveds.push(callback);
    }
}
function $f347e48613385d9c$var$onAttributesAdded(callback) {
    $f347e48613385d9c$var$onAttributeAddeds.push(callback);
}
function $f347e48613385d9c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f347e48613385d9c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
var $f347e48613385d9c$var$observer = new MutationObserver($f347e48613385d9c$var$onMutate);
var $f347e48613385d9c$var$currentlyObserving = false;
function $f347e48613385d9c$var$startObservingMutations() {
    $f347e48613385d9c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f347e48613385d9c$var$currentlyObserving = true;
}
function $f347e48613385d9c$var$stopObservingMutations() {
    $f347e48613385d9c$var$flushObserver();
    $f347e48613385d9c$var$observer.disconnect();
    $f347e48613385d9c$var$currentlyObserving = false;
}
var $f347e48613385d9c$var$recordQueue = [];
var $f347e48613385d9c$var$willProcessRecordQueue = false;
function $f347e48613385d9c$var$flushObserver() {
    $f347e48613385d9c$var$recordQueue = $f347e48613385d9c$var$recordQueue.concat($f347e48613385d9c$var$observer.takeRecords());
    if ($f347e48613385d9c$var$recordQueue.length && !$f347e48613385d9c$var$willProcessRecordQueue) {
        $f347e48613385d9c$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $f347e48613385d9c$var$processRecordQueue();
            $f347e48613385d9c$var$willProcessRecordQueue = false;
        });
    }
}
function $f347e48613385d9c$var$processRecordQueue() {
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$recordQueue);
    $f347e48613385d9c$var$recordQueue.length = 0;
}
function $f347e48613385d9c$var$mutateDom(callback) {
    if (!$f347e48613385d9c$var$currentlyObserving) return callback();
    $f347e48613385d9c$var$stopObservingMutations();
    let result = callback();
    $f347e48613385d9c$var$startObservingMutations();
    return result;
}
var $f347e48613385d9c$var$isCollecting = false;
var $f347e48613385d9c$var$deferredMutations = [];
function $f347e48613385d9c$var$deferMutations() {
    $f347e48613385d9c$var$isCollecting = true;
}
function $f347e48613385d9c$var$flushAndStopDeferringMutations() {
    $f347e48613385d9c$var$isCollecting = false;
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$deferredMutations);
    $f347e48613385d9c$var$deferredMutations = [];
}
function $f347e48613385d9c$var$onMutate(mutations) {
    if ($f347e48613385d9c$var$isCollecting) {
        $f347e48613385d9c$var$deferredMutations = $f347e48613385d9c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = new Map();
    let removedAttributes = new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $f347e48613385d9c$var$onElRemoveds.forEach((i)=>i(node));
        if (node._x_cleanups) while(node._x_cleanups.length)node._x_cleanups.pop()();
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $f347e48613385d9c$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f347e48613385d9c$var$scope(node) {
    return $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$closestDataStack(node));
}
function $f347e48613385d9c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f347e48613385d9c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f347e48613385d9c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f347e48613385d9c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f347e48613385d9c$var$closestDataStack(node.parentNode);
}
function $f347e48613385d9c$var$mergeProxies(objects) {
    let thisProxy = new Proxy({}, {
        ownKeys: ()=>{
            return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
        },
        has: (target, name)=>{
            return objects.some((obj)=>obj.hasOwnProperty(name));
        },
        get: (target, name)=>{
            return (objects.find((obj)=>{
                if (obj.hasOwnProperty(name)) {
                    let descriptor = Object.getOwnPropertyDescriptor(obj, name);
                    if (descriptor.get && descriptor.get._x_alreadyBound || descriptor.set && descriptor.set._x_alreadyBound) return true;
                    if ((descriptor.get || descriptor.set) && descriptor.enumerable) {
                        let getter = descriptor.get;
                        let setter = descriptor.set;
                        let property = descriptor;
                        getter = getter && getter.bind(thisProxy);
                        setter = setter && setter.bind(thisProxy);
                        if (getter) getter._x_alreadyBound = true;
                        if (setter) setter._x_alreadyBound = true;
                        Object.defineProperty(obj, name, {
                            ...property,
                            get: getter,
                            set: setter
                        });
                    }
                    return true;
                }
                return false;
            }) || {})[name];
        },
        set: (target, name, value)=>{
            let closestObjectWithKey = objects.find((obj)=>obj.hasOwnProperty(name));
            if (closestObjectWithKey) closestObjectWithKey[name] = value;
            else objects[objects.length - 1][name] = value;
            return true;
        }
    });
    return thisProxy;
}
// packages/alpinejs/src/interceptor.js
function $f347e48613385d9c$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f347e48613385d9c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f347e48613385d9c$var$get(data2, path), (value)=>$f347e48613385d9c$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f347e48613385d9c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f347e48613385d9c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f347e48613385d9c$var$magics = {};
function $f347e48613385d9c$var$magic(name, callback) {
    $f347e48613385d9c$var$magics[name] = callback;
}
function $f347e48613385d9c$var$injectMagics(obj, el) {
    Object.entries($f347e48613385d9c$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $f347e48613385d9c$var$interceptor,
                    ...utilities
                };
                $f347e48613385d9c$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $f347e48613385d9c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f347e48613385d9c$var$handleError(e, el, expression);
    }
}
function $f347e48613385d9c$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f347e48613385d9c$var$shouldAutoEvaluateFunctions = true;
function $f347e48613385d9c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f347e48613385d9c$var$shouldAutoEvaluateFunctions;
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = false;
    callback();
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = cache;
}
function $f347e48613385d9c$var$evaluate(el, expression, extras = {}) {
    let result;
    $f347e48613385d9c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f347e48613385d9c$var$evaluateLater(...args) {
    return $f347e48613385d9c$var$theEvaluatorFunction(...args);
}
var $f347e48613385d9c$var$theEvaluatorFunction = $f347e48613385d9c$var$normalEvaluator;
function $f347e48613385d9c$var$setEvaluator(newEvaluator) {
    $f347e48613385d9c$var$theEvaluatorFunction = newEvaluator;
}
function $f347e48613385d9c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f347e48613385d9c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f347e48613385d9c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, expression) : $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f347e48613385d9c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f347e48613385d9c$var$evaluatorMemo = {};
function $f347e48613385d9c$var$generateFunctionFromString(expression, el) {
    if ($f347e48613385d9c$var$evaluatorMemo[expression]) return $f347e48613385d9c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression) || /^(let|const)\s/.test(expression) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            return new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
        } catch (error2) {
            $f347e48613385d9c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f347e48613385d9c$var$evaluatorMemo[expression] = func;
    return func;
}
function $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f347e48613385d9c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression));
            if (func.finished) {
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f347e48613385d9c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f347e48613385d9c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f347e48613385d9c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f347e48613385d9c$var$prefixAsString = "x-";
function $f347e48613385d9c$var$prefix(subject = "") {
    return $f347e48613385d9c$var$prefixAsString + subject;
}
function $f347e48613385d9c$var$setPrefix(newPrefix) {
    $f347e48613385d9c$var$prefixAsString = newPrefix;
}
var $f347e48613385d9c$var$directiveHandlers = {};
function $f347e48613385d9c$var$directive(name, callback) {
    $f347e48613385d9c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f347e48613385d9c$var$directiveHandlers[directive2]) {
                console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                return;
            }
            const pos = $f347e48613385d9c$var$directiveOrder.indexOf(directive2);
            $f347e48613385d9c$var$directiveOrder.splice(pos >= 0 ? pos : $f347e48613385d9c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f347e48613385d9c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f347e48613385d9c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f347e48613385d9c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f347e48613385d9c$var$outNonAlpineAttributes).map($f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f347e48613385d9c$var$byPriority);
    return directives2.map((directive2)=>{
        return $f347e48613385d9c$var$getDirectiveHandler(el, directive2);
    });
}
function $f347e48613385d9c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f347e48613385d9c$var$toTransformedAttributes()).filter((attr)=>!$f347e48613385d9c$var$outNonAlpineAttributes(attr));
}
var $f347e48613385d9c$var$isDeferringHandlers = false;
var $f347e48613385d9c$var$directiveHandlerStacks = new Map();
var $f347e48613385d9c$var$currentHandlerStackKey = Symbol();
function $f347e48613385d9c$var$deferHandlingDirectives(callback) {
    $f347e48613385d9c$var$isDeferringHandlers = true;
    let key = Symbol();
    $f347e48613385d9c$var$currentHandlerStackKey = key;
    $f347e48613385d9c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f347e48613385d9c$var$directiveHandlerStacks.get(key).length)$f347e48613385d9c$var$directiveHandlerStacks.get(key).shift()();
        $f347e48613385d9c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f347e48613385d9c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f347e48613385d9c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f347e48613385d9c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f347e48613385d9c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f347e48613385d9c$var$evaluateLater.bind($f347e48613385d9c$var$evaluateLater, el),
        evaluate: $f347e48613385d9c$var$evaluate.bind($f347e48613385d9c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f347e48613385d9c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler3 = $f347e48613385d9c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    $f347e48613385d9c$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler3.inline && handler3.inline(el, directive2, utilities);
        handler3 = handler3.bind(handler3, el, directive2, utilities);
        $f347e48613385d9c$var$isDeferringHandlers ? $f347e48613385d9c$var$directiveHandlerStacks.get($f347e48613385d9c$var$currentHandlerStackKey).push(handler3) : handler3();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f347e48613385d9c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f347e48613385d9c$var$into = (i)=>i;
function $f347e48613385d9c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f347e48613385d9c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f347e48613385d9c$var$attributeTransformers = [];
function $f347e48613385d9c$var$mapAttributes(callback) {
    $f347e48613385d9c$var$attributeTransformers.push(callback);
}
function $f347e48613385d9c$var$outNonAlpineAttributes({ name: name }) {
    return $f347e48613385d9c$var$alpineAttributeRegex().test(name);
}
var $f347e48613385d9c$var$alpineAttributeRegex = ()=>new RegExp(`^${$f347e48613385d9c$var$prefixAsString}([^:^.]+)\\b`);
function $f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f347e48613385d9c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f347e48613385d9c$var$DEFAULT = "DEFAULT";
var $f347e48613385d9c$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f347e48613385d9c$var$DEFAULT,
    "teleport"
];
function $f347e48613385d9c$var$byPriority(a, b) {
    let typeA = $f347e48613385d9c$var$directiveOrder.indexOf(a.type) === -1 ? $f347e48613385d9c$var$DEFAULT : a.type;
    let typeB = $f347e48613385d9c$var$directiveOrder.indexOf(b.type) === -1 ? $f347e48613385d9c$var$DEFAULT : b.type;
    return $f347e48613385d9c$var$directiveOrder.indexOf(typeA) - $f347e48613385d9c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $f347e48613385d9c$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f347e48613385d9c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f347e48613385d9c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f347e48613385d9c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f347e48613385d9c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f347e48613385d9c$var$started = false;
function $f347e48613385d9c$var$start() {
    if ($f347e48613385d9c$var$started) $f347e48613385d9c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f347e48613385d9c$var$started = true;
    if (!document.body) $f347e48613385d9c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f347e48613385d9c$var$dispatch(document, "alpine:init");
    $f347e48613385d9c$var$dispatch(document, "alpine:initializing");
    $f347e48613385d9c$var$startObservingMutations();
    $f347e48613385d9c$var$onElAdded((el)=>$f347e48613385d9c$var$initTree(el, $f347e48613385d9c$var$walk));
    $f347e48613385d9c$var$onElRemoved((el)=>$f347e48613385d9c$var$destroyTree(el));
    $f347e48613385d9c$var$onAttributesAdded((el, attrs)=>{
        $f347e48613385d9c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f347e48613385d9c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f347e48613385d9c$var$allSelectors())).filter(outNestedComponents).forEach((el)=>{
        $f347e48613385d9c$var$initTree(el);
    });
    $f347e48613385d9c$var$dispatch(document, "alpine:initialized");
}
var $f347e48613385d9c$var$rootSelectorCallbacks = [];
var $f347e48613385d9c$var$initSelectorCallbacks = [];
function $f347e48613385d9c$var$rootSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f347e48613385d9c$var$allSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.concat($f347e48613385d9c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f347e48613385d9c$var$addRootSelector(selectorCallback) {
    $f347e48613385d9c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$addInitSelector(selectorCallback) {
    $f347e48613385d9c$var$initSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$closestRoot(el, includeInitSelectors = false) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f347e48613385d9c$var$allSelectors() : $f347e48613385d9c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f347e48613385d9c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f347e48613385d9c$var$findClosest(el.parentElement, callback);
}
function $f347e48613385d9c$var$isRoot(el) {
    return $f347e48613385d9c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f347e48613385d9c$var$initInterceptors2 = [];
function $f347e48613385d9c$var$interceptInit(callback) {
    $f347e48613385d9c$var$initInterceptors2.push(callback);
}
function $f347e48613385d9c$var$initTree(el, walker = $f347e48613385d9c$var$walk, intercept = ()=>{}) {
    $f347e48613385d9c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $f347e48613385d9c$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $f347e48613385d9c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $f347e48613385d9c$var$destroyTree(root) {
    $f347e48613385d9c$var$walk(root, (el)=>$f347e48613385d9c$var$cleanupAttributes(el));
}
// packages/alpinejs/src/nextTick.js
var $f347e48613385d9c$var$tickStack = [];
var $f347e48613385d9c$var$isHolding = false;
function $f347e48613385d9c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f347e48613385d9c$var$isHolding || setTimeout(()=>{
            $f347e48613385d9c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f347e48613385d9c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f347e48613385d9c$var$releaseNextTicks() {
    $f347e48613385d9c$var$isHolding = false;
    while($f347e48613385d9c$var$tickStack.length)$f347e48613385d9c$var$tickStack.shift()();
}
function $f347e48613385d9c$var$holdNextTicks() {
    $f347e48613385d9c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f347e48613385d9c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f347e48613385d9c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f347e48613385d9c$var$setClasses(el, value());
    return $f347e48613385d9c$var$setClassesFromString(el, value);
}
function $f347e48613385d9c$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f347e48613385d9c$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f347e48613385d9c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setStylesFromObject(el, value);
    return $f347e48613385d9c$var$setStylesFromString(el, value);
}
function $f347e48613385d9c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f347e48613385d9c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f347e48613385d9c$var$setStyles(el, previousStyles);
    };
}
function $f347e48613385d9c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f347e48613385d9c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f347e48613385d9c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f347e48613385d9c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f347e48613385d9c$var$registerTransitionsFromClassString(el, expression, value);
});
function $f347e48613385d9c$var$registerTransitionsFromClassString(el, classString, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setClasses, "");
    let directiveStorageMap = {
        enter: (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        leave: (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f347e48613385d9c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f347e48613385d9c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f347e48613385d9c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f347e48613385d9c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f347e48613385d9c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f347e48613385d9c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f347e48613385d9c$var$closestHide(parent);
}
function $f347e48613385d9c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f347e48613385d9c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f347e48613385d9c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f347e48613385d9c$var$once(()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f347e48613385d9c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f347e48613385d9c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f347e48613385d9c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f347e48613385d9c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f347e48613385d9c$var$mutateDom(()=>{
                stages.end();
            });
            $f347e48613385d9c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f347e48613385d9c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f347e48613385d9c$var$isCloning = false;
function $f347e48613385d9c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f347e48613385d9c$var$isCloning ? fallback(...args) : callback(...args);
}
function $f347e48613385d9c$var$onlyDuringClone(callback) {
    return (...args)=>$f347e48613385d9c$var$isCloning && callback(...args);
}
function $f347e48613385d9c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$cloneTree(newEl);
    });
    $f347e48613385d9c$var$isCloning = false;
}
function $f347e48613385d9c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f347e48613385d9c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f347e48613385d9c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f347e48613385d9c$var$initTree(el, shallowWalker);
}
function $f347e48613385d9c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f347e48613385d9c$var$effect;
    $f347e48613385d9c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f347e48613385d9c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f347e48613385d9c$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $f347e48613385d9c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f347e48613385d9c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f347e48613385d9c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f347e48613385d9c$var$bindInputValue(el, value);
            break;
        case "style":
            $f347e48613385d9c$var$bindStyles(el, value);
            break;
        case "class":
            $f347e48613385d9c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f347e48613385d9c$var$bindAttribute(el, name, value);
            break;
    }
}
function $f347e48613385d9c$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) el.checked = $f347e48613385d9c$var$checkedAttrLooseCompare(el.value, value);
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Number.isInteger(value) && !Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f347e48613385d9c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f347e48613385d9c$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value;
    }
}
function $f347e48613385d9c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f347e48613385d9c$var$setClasses(el, value);
}
function $f347e48613385d9c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f347e48613385d9c$var$setStyles(el, value);
}
function $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value) {
    $f347e48613385d9c$var$bindAttribute(el, name, value);
    $f347e48613385d9c$var$setPropertyIfChanged(el, name, value);
}
function $f347e48613385d9c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f347e48613385d9c$var$isBooleanAttr(name)) value = name;
        $f347e48613385d9c$var$setIfChanged(el, name, value);
    }
}
function $f347e48613385d9c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f347e48613385d9c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f347e48613385d9c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f347e48613385d9c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f347e48613385d9c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f347e48613385d9c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $f347e48613385d9c$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f347e48613385d9c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/plugin.js
function $f347e48613385d9c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f347e48613385d9c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f347e48613385d9c$var$stores = {};
var $f347e48613385d9c$var$isReactive = false;
function $f347e48613385d9c$var$store(name, value) {
    if (!$f347e48613385d9c$var$isReactive) {
        $f347e48613385d9c$var$stores = $f347e48613385d9c$var$reactive($f347e48613385d9c$var$stores);
        $f347e48613385d9c$var$isReactive = true;
    }
    if (value === void 0) return $f347e48613385d9c$var$stores[name];
    $f347e48613385d9c$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f347e48613385d9c$var$stores[name].init();
    $f347e48613385d9c$var$initInterceptors($f347e48613385d9c$var$stores[name]);
}
function $f347e48613385d9c$var$getStores() {
    return $f347e48613385d9c$var$stores;
}
// packages/alpinejs/src/binds.js
var $f347e48613385d9c$var$binds = {};
function $f347e48613385d9c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) $f347e48613385d9c$var$applyBindingsObject(name, getBindings());
    else $f347e48613385d9c$var$binds[name] = getBindings;
}
function $f347e48613385d9c$var$injectBindingProviders(obj) {
    Object.entries($f347e48613385d9c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f347e48613385d9c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f347e48613385d9c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f347e48613385d9c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
}
// packages/alpinejs/src/datas.js
var $f347e48613385d9c$var$datas = {};
function $f347e48613385d9c$var$data(name, callback) {
    $f347e48613385d9c$var$datas[name] = callback;
}
function $f347e48613385d9c$var$injectDataProviders(obj, context) {
    Object.entries($f347e48613385d9c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f347e48613385d9c$var$Alpine = {
    get reactive () {
        return $f347e48613385d9c$var$reactive;
    },
    get release () {
        return $f347e48613385d9c$var$release;
    },
    get effect () {
        return $f347e48613385d9c$var$effect;
    },
    get raw () {
        return $f347e48613385d9c$var$raw;
    },
    version: "3.12.2",
    flushAndStopDeferringMutations: $f347e48613385d9c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f347e48613385d9c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f347e48613385d9c$var$disableEffectScheduling,
    startObservingMutations: $f347e48613385d9c$var$startObservingMutations,
    stopObservingMutations: $f347e48613385d9c$var$stopObservingMutations,
    setReactivityEngine: $f347e48613385d9c$var$setReactivityEngine,
    closestDataStack: $f347e48613385d9c$var$closestDataStack,
    skipDuringClone: $f347e48613385d9c$var$skipDuringClone,
    onlyDuringClone: $f347e48613385d9c$var$onlyDuringClone,
    addRootSelector: $f347e48613385d9c$var$addRootSelector,
    addInitSelector: $f347e48613385d9c$var$addInitSelector,
    addScopeToNode: $f347e48613385d9c$var$addScopeToNode,
    deferMutations: $f347e48613385d9c$var$deferMutations,
    mapAttributes: $f347e48613385d9c$var$mapAttributes,
    evaluateLater: $f347e48613385d9c$var$evaluateLater,
    interceptInit: $f347e48613385d9c$var$interceptInit,
    setEvaluator: $f347e48613385d9c$var$setEvaluator,
    mergeProxies: $f347e48613385d9c$var$mergeProxies,
    findClosest: $f347e48613385d9c$var$findClosest,
    closestRoot: $f347e48613385d9c$var$closestRoot,
    destroyTree: $f347e48613385d9c$var$destroyTree,
    interceptor: $f347e48613385d9c$var$interceptor,
    transition: $f347e48613385d9c$var$transition,
    setStyles: $f347e48613385d9c$var$setStyles,
    mutateDom: $f347e48613385d9c$var$mutateDom,
    directive: $f347e48613385d9c$var$directive,
    throttle: $f347e48613385d9c$var$throttle,
    debounce: $f347e48613385d9c$var$debounce,
    evaluate: $f347e48613385d9c$var$evaluate,
    initTree: $f347e48613385d9c$var$initTree,
    nextTick: $f347e48613385d9c$var$nextTick,
    prefixed: $f347e48613385d9c$var$prefix,
    prefix: $f347e48613385d9c$var$setPrefix,
    plugin: $f347e48613385d9c$var$plugin,
    magic: $f347e48613385d9c$var$magic,
    store: $f347e48613385d9c$var$store,
    start: $f347e48613385d9c$var$start,
    clone: $f347e48613385d9c$var$clone,
    bound: $f347e48613385d9c$var$getBinding,
    $data: $f347e48613385d9c$var$scope,
    walk: $f347e48613385d9c$var$walk,
    data: $f347e48613385d9c$var$data,
    bind: $f347e48613385d9c$var$bind2
};
var $f347e48613385d9c$var$alpine_default = $f347e48613385d9c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f347e48613385d9c$var$makeMap(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f347e48613385d9c$var$PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
var $f347e48613385d9c$var$slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
var $f347e48613385d9c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f347e48613385d9c$var$isBooleanAttr2 = /* @__PURE__ */ $f347e48613385d9c$var$makeMap($f347e48613385d9c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f347e48613385d9c$var$EMPTY_OBJ = Object.freeze({});
var $f347e48613385d9c$var$EMPTY_ARR = Object.freeze([]);
var $f347e48613385d9c$var$extend = Object.assign;
var $f347e48613385d9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f347e48613385d9c$var$hasOwn = (val, key)=>$f347e48613385d9c$var$hasOwnProperty.call(val, key);
var $f347e48613385d9c$var$isArray = Array.isArray;
var $f347e48613385d9c$var$isMap = (val)=>$f347e48613385d9c$var$toTypeString(val) === "[object Map]";
var $f347e48613385d9c$var$isString = (val)=>typeof val === "string";
var $f347e48613385d9c$var$isSymbol = (val)=>typeof val === "symbol";
var $f347e48613385d9c$var$isObject = (val)=>val !== null && typeof val === "object";
var $f347e48613385d9c$var$objectToString = Object.prototype.toString;
var $f347e48613385d9c$var$toTypeString = (value)=>$f347e48613385d9c$var$objectToString.call(value);
var $f347e48613385d9c$var$toRawType = (value)=>{
    return $f347e48613385d9c$var$toTypeString(value).slice(8, -1);
};
var $f347e48613385d9c$var$isIntegerKey = (key)=>$f347e48613385d9c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f347e48613385d9c$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f347e48613385d9c$var$camelizeRE = /-(\w)/g;
var $f347e48613385d9c$var$camelize = $f347e48613385d9c$var$cacheStringFunction((str)=>{
    return str.replace($f347e48613385d9c$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f347e48613385d9c$var$hyphenateRE = /\B([A-Z])/g;
var $f347e48613385d9c$var$hyphenate = $f347e48613385d9c$var$cacheStringFunction((str)=>str.replace($f347e48613385d9c$var$hyphenateRE, "-$1").toLowerCase());
var $f347e48613385d9c$var$capitalize = $f347e48613385d9c$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f347e48613385d9c$var$toHandlerKey = $f347e48613385d9c$var$cacheStringFunction((str)=>str ? `on${$f347e48613385d9c$var$capitalize(str)}` : ``);
var $f347e48613385d9c$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f347e48613385d9c$var$targetMap = new WeakMap();
var $f347e48613385d9c$var$effectStack = [];
var $f347e48613385d9c$var$activeEffect;
var $f347e48613385d9c$var$ITERATE_KEY = Symbol("iterate");
var $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f347e48613385d9c$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f347e48613385d9c$var$effect2(fn, options = $f347e48613385d9c$var$EMPTY_OBJ) {
    if ($f347e48613385d9c$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f347e48613385d9c$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f347e48613385d9c$var$stop(effect3) {
    if (effect3.active) {
        $f347e48613385d9c$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f347e48613385d9c$var$uid = 0;
function $f347e48613385d9c$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f347e48613385d9c$var$effectStack.includes(effect3)) {
            $f347e48613385d9c$var$cleanup(effect3);
            try {
                $f347e48613385d9c$var$enableTracking();
                $f347e48613385d9c$var$effectStack.push(effect3);
                $f347e48613385d9c$var$activeEffect = effect3;
                return fn();
            } finally{
                $f347e48613385d9c$var$effectStack.pop();
                $f347e48613385d9c$var$resetTracking();
                $f347e48613385d9c$var$activeEffect = $f347e48613385d9c$var$effectStack[$f347e48613385d9c$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f347e48613385d9c$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f347e48613385d9c$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f347e48613385d9c$var$shouldTrack = true;
var $f347e48613385d9c$var$trackStack = [];
function $f347e48613385d9c$var$pauseTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = false;
}
function $f347e48613385d9c$var$enableTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = true;
}
function $f347e48613385d9c$var$resetTracking() {
    const last = $f347e48613385d9c$var$trackStack.pop();
    $f347e48613385d9c$var$shouldTrack = last === void 0 ? true : last;
}
function $f347e48613385d9c$var$track(target, type, key) {
    if (!$f347e48613385d9c$var$shouldTrack || $f347e48613385d9c$var$activeEffect === void 0) return;
    let depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) $f347e48613385d9c$var$targetMap.set(target, depsMap = new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = new Set());
    if (!dep.has($f347e48613385d9c$var$activeEffect)) {
        dep.add($f347e48613385d9c$var$activeEffect);
        $f347e48613385d9c$var$activeEffect.deps.push(dep);
        if ($f347e48613385d9c$var$activeEffect.options.onTrack) $f347e48613385d9c$var$activeEffect.options.onTrack({
            effect: $f347e48613385d9c$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f347e48613385d9c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f347e48613385d9c$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f347e48613385d9c$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                } else if ($f347e48613385d9c$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f347e48613385d9c$var$isNonTrackableKeys = /* @__PURE__ */ $f347e48613385d9c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f347e48613385d9c$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f347e48613385d9c$var$isSymbol));
var $f347e48613385d9c$var$get2 = /* @__PURE__ */ $f347e48613385d9c$var$createGetter();
var $f347e48613385d9c$var$shallowGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(false, true);
var $f347e48613385d9c$var$readonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true);
var $f347e48613385d9c$var$shallowReadonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true, true);
var $f347e48613385d9c$var$arrayInstrumentations = {};
[
    "includes",
    "indexOf",
    "lastIndexOf"
].forEach((key)=>{
    const method = Array.prototype[key];
    $f347e48613385d9c$var$arrayInstrumentations[key] = function(...args) {
        const arr = $f347e48613385d9c$var$toRaw(this);
        for(let i = 0, l = this.length; i < l; i++)$f347e48613385d9c$var$track(arr, "get", i + "");
        const res = method.apply(arr, args);
        if (res === -1 || res === false) return method.apply(arr, args.map($f347e48613385d9c$var$toRaw));
        else return res;
    };
});
[
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
].forEach((key)=>{
    const method = Array.prototype[key];
    $f347e48613385d9c$var$arrayInstrumentations[key] = function(...args) {
        $f347e48613385d9c$var$pauseTracking();
        const res = method.apply(this, args);
        $f347e48613385d9c$var$resetTracking();
        return res;
    };
});
function $f347e48613385d9c$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f347e48613385d9c$var$shallowReadonlyMap : $f347e48613385d9c$var$readonlyMap : shallow ? $f347e48613385d9c$var$shallowReactiveMap : $f347e48613385d9c$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f347e48613385d9c$var$isArray(target);
        if (!isReadonly && targetIsArray && $f347e48613385d9c$var$hasOwn($f347e48613385d9c$var$arrayInstrumentations, key)) return Reflect.get($f347e48613385d9c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f347e48613385d9c$var$isSymbol(key) ? $f347e48613385d9c$var$builtInSymbols.has(key) : $f347e48613385d9c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f347e48613385d9c$var$track(target, "get", key);
        if (shallow) return res;
        if ($f347e48613385d9c$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f347e48613385d9c$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f347e48613385d9c$var$isObject(res)) return isReadonly ? $f347e48613385d9c$var$readonly(res) : $f347e48613385d9c$var$reactive2(res);
        return res;
    };
}
var $f347e48613385d9c$var$set2 = /* @__PURE__ */ $f347e48613385d9c$var$createSetter();
var $f347e48613385d9c$var$shallowSet = /* @__PURE__ */ $f347e48613385d9c$var$createSetter(true);
function $f347e48613385d9c$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f347e48613385d9c$var$toRaw(value);
            oldValue = $f347e48613385d9c$var$toRaw(oldValue);
            if (!$f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isRef(oldValue) && !$f347e48613385d9c$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isIntegerKey(key) ? Number(key) < target.length : $f347e48613385d9c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f347e48613385d9c$var$toRaw(receiver)) {
            if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
            else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f347e48613385d9c$var$deleteProperty(target, key) {
    const hadKey = $f347e48613385d9c$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f347e48613385d9c$var$isSymbol(key) || !$f347e48613385d9c$var$builtInSymbols.has(key)) $f347e48613385d9c$var$track(target, "has", key);
    return result;
}
function $f347e48613385d9c$var$ownKeys(target) {
    $f347e48613385d9c$var$track(target, "iterate", $f347e48613385d9c$var$isArray(target) ? "length" : $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f347e48613385d9c$var$mutableHandlers = {
    get: $f347e48613385d9c$var$get2,
    set: $f347e48613385d9c$var$set2,
    deleteProperty: $f347e48613385d9c$var$deleteProperty,
    has: $f347e48613385d9c$var$has,
    ownKeys: $f347e48613385d9c$var$ownKeys
};
var $f347e48613385d9c$var$readonlyHandlers = {
    get: $f347e48613385d9c$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f347e48613385d9c$var$shallowReactiveHandlers = $f347e48613385d9c$var$extend({}, $f347e48613385d9c$var$mutableHandlers, {
    get: $f347e48613385d9c$var$shallowGet,
    set: $f347e48613385d9c$var$shallowSet
});
var $f347e48613385d9c$var$shallowReadonlyHandlers = $f347e48613385d9c$var$extend({}, $f347e48613385d9c$var$readonlyHandlers, {
    get: $f347e48613385d9c$var$shallowReadonlyGet
});
var $f347e48613385d9c$var$toReactive = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$reactive2(value) : value;
var $f347e48613385d9c$var$toReadonly = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$readonly(value) : value;
var $f347e48613385d9c$var$toShallow = (value)=>value;
var $f347e48613385d9c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f347e48613385d9c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f347e48613385d9c$var$getProto(rawTarget);
    const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f347e48613385d9c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f347e48613385d9c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f347e48613385d9c$var$track($f347e48613385d9c$var$toRaw(target), "iterate", $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f347e48613385d9c$var$add(value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const proto = $f347e48613385d9c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f347e48613385d9c$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f347e48613385d9c$var$set$1(key, value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
    else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f347e48613385d9c$var$deleteEntry(key) {
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$clear() {
    const target = $f347e48613385d9c$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f347e48613385d9c$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f347e48613385d9c$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f347e48613385d9c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", $f347e48613385d9c$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f347e48613385d9c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const targetIsMap = $f347e48613385d9c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", isKeyOnly ? $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY : $f347e48613385d9c$var$ITERATE_KEY);
        return {
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f347e48613385d9c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f347e48613385d9c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f347e48613385d9c$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
var $f347e48613385d9c$var$mutableInstrumentations = {
    get (key) {
        return $f347e48613385d9c$var$get$1(this, key);
    },
    get size () {
        return $f347e48613385d9c$var$size(this);
    },
    has: $f347e48613385d9c$var$has$1,
    add: $f347e48613385d9c$var$add,
    set: $f347e48613385d9c$var$set$1,
    delete: $f347e48613385d9c$var$deleteEntry,
    clear: $f347e48613385d9c$var$clear,
    forEach: $f347e48613385d9c$var$createForEach(false, false)
};
var $f347e48613385d9c$var$shallowInstrumentations = {
    get (key) {
        return $f347e48613385d9c$var$get$1(this, key, false, true);
    },
    get size () {
        return $f347e48613385d9c$var$size(this);
    },
    has: $f347e48613385d9c$var$has$1,
    add: $f347e48613385d9c$var$add,
    set: $f347e48613385d9c$var$set$1,
    delete: $f347e48613385d9c$var$deleteEntry,
    clear: $f347e48613385d9c$var$clear,
    forEach: $f347e48613385d9c$var$createForEach(false, true)
};
var $f347e48613385d9c$var$readonlyInstrumentations = {
    get (key) {
        return $f347e48613385d9c$var$get$1(this, key, true);
    },
    get size () {
        return $f347e48613385d9c$var$size(this, true);
    },
    has (key) {
        return $f347e48613385d9c$var$has$1.call(this, key, true);
    },
    add: $f347e48613385d9c$var$createReadonlyMethod("add"),
    set: $f347e48613385d9c$var$createReadonlyMethod("set"),
    delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
    clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
    forEach: $f347e48613385d9c$var$createForEach(true, false)
};
var $f347e48613385d9c$var$shallowReadonlyInstrumentations = {
    get (key) {
        return $f347e48613385d9c$var$get$1(this, key, true, true);
    },
    get size () {
        return $f347e48613385d9c$var$size(this, true);
    },
    has (key) {
        return $f347e48613385d9c$var$has$1.call(this, key, true);
    },
    add: $f347e48613385d9c$var$createReadonlyMethod("add"),
    set: $f347e48613385d9c$var$createReadonlyMethod("set"),
    delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
    clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
    forEach: $f347e48613385d9c$var$createForEach(true, true)
};
var $f347e48613385d9c$var$iteratorMethods = [
    "keys",
    "values",
    "entries",
    Symbol.iterator
];
$f347e48613385d9c$var$iteratorMethods.forEach((method)=>{
    $f347e48613385d9c$var$mutableInstrumentations[method] = $f347e48613385d9c$var$createIterableMethod(method, false, false);
    $f347e48613385d9c$var$readonlyInstrumentations[method] = $f347e48613385d9c$var$createIterableMethod(method, true, false);
    $f347e48613385d9c$var$shallowInstrumentations[method] = $f347e48613385d9c$var$createIterableMethod(method, false, true);
    $f347e48613385d9c$var$shallowReadonlyInstrumentations[method] = $f347e48613385d9c$var$createIterableMethod(method, true, true);
});
function $f347e48613385d9c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f347e48613385d9c$var$shallowReadonlyInstrumentations : $f347e48613385d9c$var$shallowInstrumentations : isReadonly ? $f347e48613385d9c$var$readonlyInstrumentations : $f347e48613385d9c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f347e48613385d9c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f347e48613385d9c$var$mutableCollectionHandlers = {
    get: $f347e48613385d9c$var$createInstrumentationGetter(false, false)
};
var $f347e48613385d9c$var$shallowCollectionHandlers = {
    get: $f347e48613385d9c$var$createInstrumentationGetter(false, true)
};
var $f347e48613385d9c$var$readonlyCollectionHandlers = {
    get: $f347e48613385d9c$var$createInstrumentationGetter(true, false)
};
var $f347e48613385d9c$var$shallowReadonlyCollectionHandlers = {
    get: $f347e48613385d9c$var$createInstrumentationGetter(true, true)
};
function $f347e48613385d9c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f347e48613385d9c$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f347e48613385d9c$var$reactiveMap = new WeakMap();
var $f347e48613385d9c$var$shallowReactiveMap = new WeakMap();
var $f347e48613385d9c$var$readonlyMap = new WeakMap();
var $f347e48613385d9c$var$shallowReadonlyMap = new WeakMap();
function $f347e48613385d9c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f347e48613385d9c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f347e48613385d9c$var$targetTypeMap($f347e48613385d9c$var$toRawType(value));
}
function $f347e48613385d9c$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f347e48613385d9c$var$createReactiveObject(target, false, $f347e48613385d9c$var$mutableHandlers, $f347e48613385d9c$var$mutableCollectionHandlers, $f347e48613385d9c$var$reactiveMap);
}
function $f347e48613385d9c$var$readonly(target) {
    return $f347e48613385d9c$var$createReactiveObject(target, true, $f347e48613385d9c$var$readonlyHandlers, $f347e48613385d9c$var$readonlyCollectionHandlers, $f347e48613385d9c$var$readonlyMap);
}
function $f347e48613385d9c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f347e48613385d9c$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f347e48613385d9c$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f347e48613385d9c$var$toRaw(observed) {
    return observed && $f347e48613385d9c$var$toRaw(observed["__v_raw"]) || observed;
}
function $f347e48613385d9c$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f347e48613385d9c$var$magic("nextTick", ()=>$f347e48613385d9c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f347e48613385d9c$var$magic("dispatch", (el)=>$f347e48613385d9c$var$dispatch.bind($f347e48613385d9c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f347e48613385d9c$var$magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$f347e48613385d9c$var$magic("store", $f347e48613385d9c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f347e48613385d9c$var$magic("data", (el)=>$f347e48613385d9c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f347e48613385d9c$var$magic("root", (el)=>$f347e48613385d9c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f347e48613385d9c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f347e48613385d9c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f347e48613385d9c$var$globalIdMemo = {};
function $f347e48613385d9c$var$findAndIncrementId(name) {
    if (!$f347e48613385d9c$var$globalIdMemo[name]) $f347e48613385d9c$var$globalIdMemo[name] = 0;
    return ++$f347e48613385d9c$var$globalIdMemo[name];
}
function $f347e48613385d9c$var$closestIdRoot(el, name) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f347e48613385d9c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f347e48613385d9c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f347e48613385d9c$var$magic("id", (el)=>(name, key = null)=>{
        let root = $f347e48613385d9c$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $f347e48613385d9c$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$f347e48613385d9c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f347e48613385d9c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f347e48613385d9c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f347e48613385d9c$var$warnMissingPluginMagic(name, magicName, slug) {
    $f347e48613385d9c$var$magic(magicName, (el)=>$f347e48613385d9c$var$warn(`You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/entangle.js
function $f347e48613385d9c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash, innerHash, outerHashLatest, innerHashLatest;
    let reference = $f347e48613385d9c$var$effect(()=>{
        let outer, inner;
        if (firstRun) {
            outer = outerGet();
            innerSet(outer);
            inner = innerGet();
            firstRun = false;
        } else {
            outer = outerGet();
            inner = innerGet();
            outerHashLatest = JSON.stringify(outer);
            innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) {
                inner = innerGet();
                innerSet(outer);
                inner = outer;
            } else {
                outerSet(inner);
                outer = inner;
            }
        }
        outerHash = JSON.stringify(outer);
        innerHash = JSON.stringify(inner);
    });
    return ()=>{
        $f347e48613385d9c$var$release(reference);
    };
}
// packages/alpinejs/src/directives/x-modelable.js
$f347e48613385d9c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                __placeholder: val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f347e48613385d9c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
var $f347e48613385d9c$var$teleportContainerDuringClone = document.createElement("div");
$f347e48613385d9c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f347e48613385d9c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f347e48613385d9c$var$teleportContainerDuringClone;
    })();
    if (!target) $f347e48613385d9c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
    $f347e48613385d9c$var$mutateDom(()=>{
        if (modifiers.includes("prepend")) target.parentNode.insertBefore(clone2, target);
        else if (modifiers.includes("append")) target.parentNode.insertBefore(clone2, target.nextSibling);
        else target.appendChild(clone2);
        $f347e48613385d9c$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    cleanup2(()=>clone2.remove());
});
// packages/alpinejs/src/directives/x-ignore.js
var $f347e48613385d9c$var$handler = ()=>{};
$f347e48613385d9c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f347e48613385d9c$var$directive("ignore", $f347e48613385d9c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f347e48613385d9c$var$directive("effect", (el, { expression: expression }, { effect: effect3 })=>effect3($f347e48613385d9c$var$evaluateLater(el, expression)));
// packages/alpinejs/src/utils/on.js
function $f347e48613385d9c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler3 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f347e48613385d9c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f347e48613385d9c$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler3 = $f347e48613385d9c$var$debounce(handler3, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler3 = $f347e48613385d9c$var$throttle(handler3, wait);
    }
    if (modifiers.includes("prevent")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler3 = wrapHandler(handler3, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler3 = wrapHandler(handler3, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler3 = wrapHandler(handler3, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler3, options);
    });
    handler3 = wrapHandler(handler3, (next, e)=>{
        if ($f347e48613385d9c$var$isKeyEvent(event)) {
            if ($f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler3, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler3, options);
    };
}
function $f347e48613385d9c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f347e48613385d9c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f347e48613385d9c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f347e48613385d9c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f347e48613385d9c$var$kebabCase2(key);
    let modifierToKeyMap = {
        ctrl: "control",
        slash: "/",
        space: " ",
        spacebar: " ",
        cmd: "meta",
        esc: "escape",
        up: "arrow-up",
        down: "arrow-down",
        left: "arrow-left",
        right: "arrow-right",
        period: ".",
        equal: "=",
        minus: "-",
        underscore: "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f347e48613385d9c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f347e48613385d9c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f347e48613385d9c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f347e48613385d9c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                __placeholder: value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f347e48613385d9c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f347e48613385d9c$var$isCloning ? ()=>{} : $f347e48613385d9c$var$on(el, event, modifiers, (e)=>{
        setValue($f347e48613385d9c$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill") && [
        null,
        ""
    ].includes(getValue())) el.dispatchEvent(new Event(event, {}));
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f347e48613385d9c$var$on(el.form, "reset", [], (e)=>{
            $f347e48613385d9c$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        value = value === void 0 ? getValue() : value;
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f347e48613385d9c$var$getInputValue(el, modifiers, event, currentValue) {
    return $f347e48613385d9c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail ?? event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = modifiers.includes("number") ? $f347e48613385d9c$var$safeParseNumber(event.target.value) : event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f347e48613385d9c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option)=>{
            let rawValue = option.value || option.text;
            return $f347e48613385d9c$var$safeParseNumber(rawValue);
        }) : Array.from(event.target.selectedOptions).map((option)=>{
            return option.value || option.text;
        });
        else {
            let rawValue = event.target.value;
            return modifiers.includes("number") ? $f347e48613385d9c$var$safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
        }
    });
}
function $f347e48613385d9c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f347e48613385d9c$var$isNumeric2(number) ? number : rawValue;
}
function $f347e48613385d9c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f347e48613385d9c$var$directive("cloak", (el)=>queueMicrotask(()=>$f347e48613385d9c$var$mutateDom(()=>el.removeAttribute($f347e48613385d9c$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f347e48613385d9c$var$addInitSelector(()=>`[${$f347e48613385d9c$var$prefix("init")}]`);
$f347e48613385d9c$var$directive("init", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f347e48613385d9c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f347e48613385d9c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f347e48613385d9c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith(":", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("bind:"))));
$f347e48613385d9c$var$directive("bind", (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $f347e48613385d9c$var$injectBindingProviders(bindingProviders);
        let getBindings = $f347e48613385d9c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f347e48613385d9c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f347e48613385d9c$var$storeKeyForXFor(el, expression);
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, value, result, modifiers));
        }));
});
function $f347e48613385d9c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f347e48613385d9c$var$addRootSelector(()=>`[${$f347e48613385d9c$var$prefix("data")}]`);
$f347e48613385d9c$var$directive("data", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { cleanup: cleanup2 })=>{
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f347e48613385d9c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f347e48613385d9c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f347e48613385d9c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f347e48613385d9c$var$injectMagics(data2, el);
    let reactiveData = $f347e48613385d9c$var$reactive(data2);
    $f347e48613385d9c$var$initInterceptors(reactiveData);
    let undo = $f347e48613385d9c$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f347e48613385d9c$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f347e48613385d9c$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
}));
// packages/alpinejs/src/directives/x-show.js
$f347e48613385d9c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f347e48613385d9c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f347e48613385d9c$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f347e48613385d9c$var$parseForExpression(expression);
    let evaluateItems = $f347e48613385d9c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f347e48613385d9c$var$evaluateLater(el, el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f347e48613385d9c$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($f347e48613385d9c$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f347e48613385d9c$var$mutateDom(()=>{
                if (!elForSpot) $f347e48613385d9c$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f347e48613385d9c$var$reactive(scope2);
            $f347e48613385d9c$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f347e48613385d9c$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f347e48613385d9c$var$initTree(clone2);
            });
            if (typeof key === "object") $f347e48613385d9c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f347e48613385d9c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f347e48613385d9c$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f347e48613385d9c$var$handler2() {}
$f347e48613385d9c$var$handler2.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f347e48613385d9c$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f347e48613385d9c$var$directive("ref", $f347e48613385d9c$var$handler2);
// packages/alpinejs/src/directives/x-if.js
$f347e48613385d9c$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
        $f347e48613385d9c$var$mutateDom(()=>{
            el.after(clone2);
            $f347e48613385d9c$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f347e48613385d9c$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($f347e48613385d9c$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f347e48613385d9c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f347e48613385d9c$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith("@", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("on:"))));
$f347e48613385d9c$var$directive("on", $f347e48613385d9c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f347e48613385d9c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f347e48613385d9c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                $event: e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f347e48613385d9c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f347e48613385d9c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f347e48613385d9c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f347e48613385d9c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f347e48613385d9c$var$warnMissingPluginDirective(name, directiveName2, slug) {
    $f347e48613385d9c$var$directive(directiveName2, (el)=>$f347e48613385d9c$var$warn(`You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f347e48613385d9c$var$alpine_default.setEvaluator($f347e48613385d9c$var$normalEvaluator);
$f347e48613385d9c$var$alpine_default.setReactivityEngine({
    reactive: $f347e48613385d9c$var$reactive2,
    effect: $f347e48613385d9c$var$effect2,
    release: $f347e48613385d9c$var$stop,
    raw: $f347e48613385d9c$var$toRaw
});
var $f347e48613385d9c$var$src_default = $f347e48613385d9c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f347e48613385d9c$export$2e2bcd8739ae039 = $f347e48613385d9c$var$src_default;


// packages/intersect/src/index.js
function $d09a060543d6a2e2$var$src_default(Alpine) {
    Alpine.directive("intersect", (el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $d09a060543d6a2e2$var$getRootMargin(modifiers),
            threshold: $d09a060543d6a2e2$var$getThreshhold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    });
}
function $d09a060543d6a2e2$var$getThreshhold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $d09a060543d6a2e2$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $d09a060543d6a2e2$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($d09a060543d6a2e2$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $d09a060543d6a2e2$export$2e2bcd8739ae039 = $d09a060543d6a2e2$var$src_default;



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $c106e002a49a00cb$var$extendStatics = function(d, b) {
    $c106e002a49a00cb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c106e002a49a00cb$var$extendStatics(d, b);
};
function $c106e002a49a00cb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c106e002a49a00cb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c106e002a49a00cb$export$18ce0697a983be9b = function() {
    $c106e002a49a00cb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c106e002a49a00cb$export$18ce0697a983be9b.apply(this, arguments);
};
function $c106e002a49a00cb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c106e002a49a00cb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c106e002a49a00cb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c106e002a49a00cb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c106e002a49a00cb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c106e002a49a00cb$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c106e002a49a00cb$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c106e002a49a00cb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c106e002a49a00cb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c106e002a49a00cb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c106e002a49a00cb$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c106e002a49a00cb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c106e002a49a00cb$export$45d3717a4c69092e(o, m, p);
}
function $c106e002a49a00cb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c106e002a49a00cb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c106e002a49a00cb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c106e002a49a00cb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c106e002a49a00cb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c106e002a49a00cb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c106e002a49a00cb$export$10c90e4f7922046c(v) {
    return this instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? (this.v = v, this) : new $c106e002a49a00cb$export$10c90e4f7922046c(v);
}
function $c106e002a49a00cb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c106e002a49a00cb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c106e002a49a00cb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c106e002a49a00cb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c106e002a49a00cb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c106e002a49a00cb$export$19a8beecd37a4c45 === "function" ? $c106e002a49a00cb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c106e002a49a00cb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c106e002a49a00cb$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c106e002a49a00cb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c106e002a49a00cb$export$45d3717a4c69092e(result, mod, k);
    }
    $c106e002a49a00cb$var$__setModuleDefault(result, mod);
    return result;
}
function $c106e002a49a00cb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c106e002a49a00cb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c106e002a49a00cb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c106e002a49a00cb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
var $c106e002a49a00cb$export$2e2bcd8739ae039 = {
    __extends: $c106e002a49a00cb$export$a8ba968b8961cb8a,
    __assign: $c106e002a49a00cb$export$18ce0697a983be9b,
    __rest: $c106e002a49a00cb$export$3c9a16f847548506,
    __decorate: $c106e002a49a00cb$export$29e00dfd3077644b,
    __param: $c106e002a49a00cb$export$d5ad3fd78186038f,
    __metadata: $c106e002a49a00cb$export$f1db080c865becb9,
    __awaiter: $c106e002a49a00cb$export$1050f835b63b671e,
    __generator: $c106e002a49a00cb$export$67ebef60e6f28a6,
    __createBinding: $c106e002a49a00cb$export$45d3717a4c69092e,
    __exportStar: $c106e002a49a00cb$export$f33643c0debef087,
    __values: $c106e002a49a00cb$export$19a8beecd37a4c45,
    __read: $c106e002a49a00cb$export$8d051b38c9118094,
    __spread: $c106e002a49a00cb$export$afc72e2116322959,
    __spreadArrays: $c106e002a49a00cb$export$6388937ca91ccae8,
    __spreadArray: $c106e002a49a00cb$export$1216008129fb82ed,
    __await: $c106e002a49a00cb$export$10c90e4f7922046c,
    __asyncGenerator: $c106e002a49a00cb$export$e427f37a30a4de9b,
    __asyncDelegator: $c106e002a49a00cb$export$bbd80228419bb833,
    __asyncValues: $c106e002a49a00cb$export$e3b29a3d6162315f,
    __makeTemplateObject: $c106e002a49a00cb$export$4fb47efe1390b86f,
    __importStar: $c106e002a49a00cb$export$c21735bcef00d192,
    __importDefault: $c106e002a49a00cb$export$da59b14a69baef04,
    __classPrivateFieldGet: $c106e002a49a00cb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c106e002a49a00cb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c106e002a49a00cb$export$81fdc39f203e4e04
};











function $e48181ba352d1ccf$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if ((0, $2600ec0fa268729d$export$7e4aa119212bc614)(next)) return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}



function $b8308a889cc84729$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $2bf1343b4ac164eb$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $b8308a889cc84729$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $b8308a889cc84729$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $26fc349e92d9489e$export$2c9e8a9632a706b2)(startTime, endTime, offset[i]),
        easing: (0, $e7e8fb4e721c4127$export$41c5e731255a462)(easing, i)
    });
}


function $184029bcb6b17be4$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) return a.value === null ? 1 : -1;
    else return a.at - b.at;
}



function $68afdcc30aeb6706$export$cddc5598d4bb8461(definition, options = {}) {
    var _a;
    const animationDefinitions = $68afdcc30aeb6706$export$ecf4a6d05c8cfe84(definition, options);
    /**
     * Create and start animations
     */ const animationFactories = animationDefinitions.map((definition)=>(0, $9ef3fcdee5d7d99d$export$c76cd972d26986f9)(...definition, (0, $77d743c5fbee771c$export$c35d437ae5945fcd))).filter(Boolean);
    return (0, $ff34fe8b644280e4$export$c5e4bb50450218c1)(animationFactories, options, // Get the duration from the first animation definition
    (_a = animationDefinitions[0]) === null || _a === void 0 ? void 0 : _a[3].duration);
}
function $68afdcc30aeb6706$export$ecf4a6d05c8cfe84(definition, _a = {}) {
    var { defaultOptions: defaultOptions = {} } = _a, timelineOptions = (0, $c106e002a49a00cb$export$3c9a16f847548506)(_a, [
        "defaultOptions"
    ]);
    const animationDefinitions = [];
    const elementSequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the definition array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < definition.length; i++){
        const segment = definition[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if ((0, $1ec475b080df4cc4$export$844ec244b1367d54)(segment)) {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $e48181ba352d1ccf$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        const [elementDefinition, keyframes, options = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (options.at !== undefined) currentTime = (0, $e48181ba352d1ccf$export$83ccd85155ba9791)(currentTime, options.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        /**
         * Find all the elements specified in the definition and parse value
         * keyframes from their timeline definitions.
         */ const elements = (0, $b9a28f0b498c113a$export$90ceba2564a894f8)(elementDefinition, elementCache);
        const numElements = elements.length;
        for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
            const element = elements[elementIndex];
            const elementSequence = $68afdcc30aeb6706$var$getElementSequence(element, elementSequences);
            for(const key in keyframes){
                const valueSequence = $68afdcc30aeb6706$var$getValueSequence(key, elementSequence);
                let valueKeyframes = (0, $330ddc5eb9100e1b$export$388e66a97327a012)(keyframes[key]);
                const valueOptions = (0, $57d7e8b2ef7ce651$export$d2312e68e1f5ad00)(options, key);
                let { duration: duration = defaultOptions.duration || (0, $dc2d63b917c60329$export$ebe90cb607ad99e).duration, easing: easing = defaultOptions.easing || (0, $dc2d63b917c60329$export$ebe90cb607ad99e).easing } = valueOptions;
                if ((0, $c0efdae2be78a137$export$d81a3021299cadf2)(easing)) {
                    (0, $82adf2b309a976d9$export$f5708dca728d7177)(key === "opacity" || valueKeyframes.length > 1, "spring must be provided 2 keyframes within timeline()");
                    const custom = easing.createAnimation(valueKeyframes, key !== "opacity", ()=>0, key);
                    easing = custom.easing;
                    valueKeyframes = custom.keyframes || valueKeyframes;
                    duration = custom.duration || duration;
                }
                const delay = (0, $98bb634993f4306d$export$4cf8f03b86be8175)(options.delay, elementIndex, numElements) || 0;
                const startTime = currentTime + delay;
                const targetTime = startTime + duration;
                /**
                 *
                 */ let { offset: offset = (0, $9b3af257d77590ba$export$24dbcec0b26e6d9d)(valueKeyframes.length) } = valueOptions;
                /**
                 * If there's only one offset of 0, fill in a second with length 1
                 *
                 * TODO: Ensure there's a test that covers this removal
                 */ if (offset.length === 1 && offset[0] === 0) offset[1] = 1;
                /**
                 * Fill out if offset if fewer offsets than keyframes
                 */ const remainder = offset.length - valueKeyframes.length;
                remainder > 0 && (0, $9b3af257d77590ba$export$dafee61230cf05c6)(offset, remainder);
                /**
                 * If only one value has been set, ie [1], push a null to the start of
                 * the keyframe array. This will let us mark a keyframe at this point
                 * that will later be hydrated with the previous value.
                 */ valueKeyframes.length === 1 && valueKeyframes.unshift(null);
                /**
                 * Add keyframes, mapping offsets to absolute time.
                 */ (0, $b8308a889cc84729$export$89dfa6760a9f76e7)(valueSequence, valueKeyframes, easing, offset, startTime, targetTime);
                maxDuration = Math.max(delay + duration, maxDuration);
                totalDuration = Math.max(targetTime, totalDuration);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ elementSequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $184029bcb6b17be4$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $b5fe3643ba3c2da8$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || (0, $dc2d63b917c60329$export$ebe90cb607ad99e).easing);
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift("linear");
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            animationDefinitions.push([
                element,
                key,
                keyframes,
                Object.assign(Object.assign(Object.assign({}, defaultOptions), {
                    duration: totalDuration,
                    easing: valueEasing,
                    offset: valueOffset
                }), timelineOptions)
            ]);
        }
    });
    return animationDefinitions;
}
function $68afdcc30aeb6706$var$getElementSequence(element, sequences) {
    !sequences.has(element) && sequences.set(element, {});
    return sequences.get(element);
}
function $68afdcc30aeb6706$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}


function $56ee21bb486a2ccd$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $56ee21bb486a2ccd$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $56ee21bb486a2ccd$var$passiveTestOptions = {
        get passive () {
            $56ee21bb486a2ccd$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $56ee21bb486a2ccd$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $56ee21bb486a2ccd$var$passiveTestOptions);
}
var $56ee21bb486a2ccd$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $56ee21bb486a2ccd$var$locks = [];
var $56ee21bb486a2ccd$var$documentListenerAdded = false;
var $56ee21bb486a2ccd$var$initialClientY = -1;
var $56ee21bb486a2ccd$var$previousBodyOverflowSetting = void 0;
var $56ee21bb486a2ccd$var$previousBodyPosition = void 0;
var $56ee21bb486a2ccd$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $56ee21bb486a2ccd$var$allowTouchMove = function allowTouchMove(el) {
    return $56ee21bb486a2ccd$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $56ee21bb486a2ccd$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($56ee21bb486a2ccd$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $56ee21bb486a2ccd$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($56ee21bb486a2ccd$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $56ee21bb486a2ccd$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($56ee21bb486a2ccd$var$previousBodyOverflowSetting === undefined) {
        $56ee21bb486a2ccd$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $56ee21bb486a2ccd$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($56ee21bb486a2ccd$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $56ee21bb486a2ccd$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $56ee21bb486a2ccd$var$previousBodyPaddingRight = undefined;
    }
    if ($56ee21bb486a2ccd$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $56ee21bb486a2ccd$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $56ee21bb486a2ccd$var$previousBodyOverflowSetting = undefined;
    }
};
var $56ee21bb486a2ccd$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($56ee21bb486a2ccd$var$previousBodyPosition === undefined) {
            $56ee21bb486a2ccd$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = "fixed";
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $56ee21bb486a2ccd$var$restorePositionSetting = function restorePositionSetting() {
    if ($56ee21bb486a2ccd$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $56ee21bb486a2ccd$var$previousBodyPosition.position;
        document.body.style.top = $56ee21bb486a2ccd$var$previousBodyPosition.top;
        document.body.style.left = $56ee21bb486a2ccd$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $56ee21bb486a2ccd$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $56ee21bb486a2ccd$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $56ee21bb486a2ccd$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $56ee21bb486a2ccd$var$initialClientY;
    if ($56ee21bb486a2ccd$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $56ee21bb486a2ccd$var$preventDefault(event);
    if ($56ee21bb486a2ccd$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $56ee21bb486a2ccd$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $56ee21bb486a2ccd$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($56ee21bb486a2ccd$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $56ee21bb486a2ccd$var$locks = [].concat($56ee21bb486a2ccd$var$_toConsumableArray($56ee21bb486a2ccd$var$locks), [
        lock
    ]);
    if ($56ee21bb486a2ccd$var$isIosDevice) $56ee21bb486a2ccd$var$setPositionFixed();
    else $56ee21bb486a2ccd$var$setOverflowHidden(options);
    if ($56ee21bb486a2ccd$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $56ee21bb486a2ccd$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $56ee21bb486a2ccd$var$handleScroll(event, targetElement);
        };
        if (!$56ee21bb486a2ccd$var$documentListenerAdded) {
            document.addEventListener("touchmove", $56ee21bb486a2ccd$var$preventDefault, $56ee21bb486a2ccd$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $56ee21bb486a2ccd$var$documentListenerAdded = true;
        }
    }
};
var $56ee21bb486a2ccd$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($56ee21bb486a2ccd$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $56ee21bb486a2ccd$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($56ee21bb486a2ccd$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $56ee21bb486a2ccd$var$preventDefault, $56ee21bb486a2ccd$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $56ee21bb486a2ccd$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $56ee21bb486a2ccd$var$initialClientY = -1;
    }
    if ($56ee21bb486a2ccd$var$isIosDevice) $56ee21bb486a2ccd$var$restorePositionSetting();
    else $56ee21bb486a2ccd$var$restoreOverflowSetting();
    $56ee21bb486a2ccd$var$locks = [];
};
var $56ee21bb486a2ccd$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $56ee21bb486a2ccd$var$locks = $56ee21bb486a2ccd$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($56ee21bb486a2ccd$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($56ee21bb486a2ccd$var$documentListenerAdded && $56ee21bb486a2ccd$var$locks.length === 0) {
            document.removeEventListener("touchmove", $56ee21bb486a2ccd$var$preventDefault, $56ee21bb486a2ccd$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $56ee21bb486a2ccd$var$documentListenerAdded = false;
        }
    }
    if ($56ee21bb486a2ccd$var$isIosDevice) $56ee21bb486a2ccd$var$restorePositionSetting();
    else $56ee21bb486a2ccd$var$restoreOverflowSetting();
};


var $72db31bd550cc612$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $72db31bd550cc612$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $72db31bd550cc612$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $72db31bd550cc612$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $72db31bd550cc612$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $72db31bd550cc612$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $72db31bd550cc612$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $72db31bd550cc612$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $72db31bd550cc612$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $72db31bd550cc612$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $72db31bd550cc612$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $72db31bd550cc612$var$root = $72db31bd550cc612$var$freeGlobal || $72db31bd550cc612$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $72db31bd550cc612$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $72db31bd550cc612$var$objectToString = $72db31bd550cc612$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $72db31bd550cc612$var$nativeMax = Math.max, $72db31bd550cc612$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $72db31bd550cc612$var$now = function() {
    return $72db31bd550cc612$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $72db31bd550cc612$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($72db31bd550cc612$var$FUNC_ERROR_TEXT);
    wait = $72db31bd550cc612$var$toNumber(wait) || 0;
    if ($72db31bd550cc612$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $72db31bd550cc612$var$nativeMax($72db31bd550cc612$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $72db31bd550cc612$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $72db31bd550cc612$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($72db31bd550cc612$var$now());
    }
    function debounced() {
        var time = $72db31bd550cc612$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $72db31bd550cc612$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($72db31bd550cc612$var$FUNC_ERROR_TEXT);
    if ($72db31bd550cc612$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $72db31bd550cc612$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $72db31bd550cc612$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $72db31bd550cc612$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $72db31bd550cc612$var$isSymbol(value) {
    return typeof value == "symbol" || $72db31bd550cc612$var$isObjectLike(value) && $72db31bd550cc612$var$objectToString.call(value) == $72db31bd550cc612$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $72db31bd550cc612$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($72db31bd550cc612$var$isSymbol(value)) return $72db31bd550cc612$var$NAN;
    if ($72db31bd550cc612$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $72db31bd550cc612$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($72db31bd550cc612$var$reTrim, "");
    var isBinary = $72db31bd550cc612$var$reIsBinary.test(value);
    return isBinary || $72db31bd550cc612$var$reIsOctal.test(value) ? $72db31bd550cc612$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $72db31bd550cc612$var$reIsBadHex.test(value) ? $72db31bd550cc612$var$NAN : +value;
}
$72db31bd550cc612$exports = $72db31bd550cc612$var$throttle;


const $71fa3e4d537c51ab$var$Navigation = ()=>{
    const navBar = document.getElementById("page-navbar");
    const navEl = document.querySelector('[x-data="menu"]');
    const navItemEls = navEl.querySelectorAll(".nav-item");
    const searchBar = document.getElementById("searchBar");
    if (!navEl) return;
    // Navbar hide on scroll
    let lastScrollTop = 0;
    window.addEventListener("scroll", (0, (/*@__PURE__*/$parcel$interopDefault($72db31bd550cc612$exports)))(()=>{
        const scrollTop = window.scrollY;
        // After 60px translate/top / hide on scroll down
        if (scrollTop >= 60) {
            if (scrollTop >= lastScrollTop) {
                navBar.classList.remove("!transform-none");
                navBar.classList.add("-translate-y-full");
                document.dispatchEvent(new Event("closeSearch"));
                closeSearch();
            } else navBar.classList.add("!transform-none");
            lastScrollTop = scrollTop;
        } else {
            navBar.classList.remove("!transform-none");
            navBar.classList.remove("-translate-y-full");
        }
    }, 100));
    document.addEventListener("nav:toggle", (e)=>{
        if (e.detail) openNav();
        else closeNav();
    });
    document.addEventListener("search:toggle", (e)=>{
        if (e.detail) openSearch();
        else closeSearch();
    });
    const openSearch = ()=>{
        searchBar.classList.add("!opacity-100", "!visible");
        setTimeout((_)=>searchBar.querySelector('input[name="s"]').focus(), 100);
    };
    const closeSearch = ()=>{
        searchBar.classList.remove("!opacity-100", "!visible");
    };
    const openNav = ()=>{
        (0, $56ee21bb486a2ccd$export$24fdf68abf432c44)(navEl.querySelector(".scroll-list"));
        (0, $68afdcc30aeb6706$export$cddc5598d4bb8461)([
            [
                navEl,
                {
                    y: 0
                },
                {
                    duration: 0.5,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ],
            [
                navItemEls,
                {
                    opacity: 1
                },
                {
                    duration: 0.3,
                    delay: (0, $98bb634993f4306d$export$ef0b4d89074db4d0)(0.1),
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ],
                    at: "-0.2"
                }
            ]
        ]);
    };
    const closeNav = (duration = 0.3)=>{
        (0, $56ee21bb486a2ccd$export$e5d0524c3725571e)(navEl.querySelector(".scroll-list"));
        (0, $68afdcc30aeb6706$export$cddc5598d4bb8461)([
            [
                navEl,
                {
                    y: "-100%"
                },
                {
                    duration: duration,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ],
            [
                navItemEls,
                {
                    opacity: 0
                },
                {
                    duration: duration,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                }
            ]
        ]);
    };
    closeNav(0);
};
var $71fa3e4d537c51ab$export$2e2bcd8739ae039 = $71fa3e4d537c51ab$var$Navigation;



const $ed1a224046efb5d7$var$CountUp = ()=>{
    // How long you want the animation to take, in ms
    const animationDuration = 2000;
    // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
    const frameDuration = 1000 / 60;
    // Use that to calculate how many frames we need to complete the animation
    const totalFrames = Math.round(animationDuration / frameDuration);
    // An ease-out function that slows the count as it progresses
    const easeOutQuad = (t)=>t * (2 - t);
    // The animation function, which takes an Element
    const animateCountUp = (el)=>{
        let frame = 0;
        const countTo = parseInt(el.innerHTML, 10);
        // Start the animation running 60 times per second
        const counter = setInterval(()=>{
            frame++;
            // Calculate our progress as a value between 0 and 1
            // Pass that value to our easing function to get our
            // progress on a curve
            const progress = easeOutQuad(frame / totalFrames);
            // Use the progress value to calculate the current count
            const currentCount = Math.round(countTo * progress);
            // If the current count has changed, update the element
            if (parseInt(el.innerHTML, 10) !== currentCount) el.innerHTML = currentCount;
            // If we’ve reached our last frame, stop the animation
            if (frame === totalFrames) clearInterval(counter);
        }, frameDuration);
    };
    // Run the animation on all elements with a class of ‘countup’
    const runAnimations = ()=>{
        const countupEls = document.querySelectorAll(".count-num");
        countupEls.forEach(animateCountUp);
    };
    const countBlock = document.querySelectorAll(".count-block");
    countBlock.forEach((block)=>{
        (0, $983dfce98d47352b$export$acb1e9cb9ce4ca56)(block, ()=>{
            runAnimations();
        });
    });
};
var $ed1a224046efb5d7$export$2e2bcd8739ae039 = $ed1a224046efb5d7$var$CountUp;



parcelRequire("9pmxg");
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $d09a060543d6a2e2$export$2e2bcd8739ae039));
window.Alpine = (0, $f347e48613385d9c$export$2e2bcd8739ae039);
(0, $f347e48613385d9c$export$2e2bcd8739ae039).start();
const $0026cc5aa8359700$var$projectLists = document.querySelectorAll(".giantpeach-gallerygrid");

if ($0026cc5aa8359700$var$projectLists.length) (parcelRequire("iqhLJ")).then(({ default: GalleryGrid })=>{
    $0026cc5aa8359700$var$projectLists.forEach((el)=>{
        GalleryGrid(el);
    });
});


const $0026cc5aa8359700$var$domReady = ()=>{
    (0, $71fa3e4d537c51ab$export$2e2bcd8739ae039)();
    (0, $ed1a224046efb5d7$export$2e2bcd8739ae039)();
    const bannerSlider = document.querySelectorAll(".banner-slider");
    let transitionableBlocks = document.querySelectorAll(".transition-block");
    document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    if (bannerSlider.length) (parcelRequire("ba3gM")).then(({ default: BannerSlider })=>{
        BannerSlider();
    });
    const productCarousel = document.querySelectorAll(".main-product-carousel");
    if (productCarousel.length) Promise.resolve((parcelRequire("9pmxg"))).then(({ default: SingleProduct })=>{
        productCarousel.forEach((el)=>{
            SingleProduct(el);
        });
    });
    let inViewStop = (0, $983dfce98d47352b$export$acb1e9cb9ce4ca56)(transitionableBlocks, ({ target: target })=>{
        (0, $e7dee9a46833b703$export$e3607ec2d7a891c4)(target, {
            opacity: 1,
            transform: "none"
        }, {
            delay: 0.2,
            duration: 0.5,
            easing: [
                0.25,
                0.1,
                0.25,
                1
            ]
        });
        return ()=>{
            (0, $e7dee9a46833b703$export$e3607ec2d7a891c4)(target, {
                opacity: 0,
                transform: "translateY(32px)"
            }, {
                duration: 0.5,
                easing: [
                    0.25,
                    0.1,
                    0.25,
                    1
                ]
            });
        };
    });
    document.addEventListener("block:load", ()=>{
        transitionableBlocks = document.querySelectorAll(".transition-block");
        inViewStop();
        inViewStop = (0, $983dfce98d47352b$export$acb1e9cb9ce4ca56)(transitionableBlocks, ({ target: target })=>{
            (0, $e7dee9a46833b703$export$e3607ec2d7a891c4)(target, {
                opactiy: 1,
                transform: "none"
            }, {
                delay: 0.2,
                duration: 0.5,
                easing: [
                    0.25,
                    0.1,
                    0.25,
                    1
                ]
            });
            return ()=>{
                (0, $e7dee9a46833b703$export$e3607ec2d7a891c4)(target, {
                    opactiy: 0,
                    transform: "translateY(32px)"
                }, {
                    duration: 0.5,
                    easing: [
                        0.25,
                        0.1,
                        0.25,
                        1
                    ]
                });
            };
        });
    });
};
document.addEventListener("DOMContentLoaded", $0026cc5aa8359700$var$domReady);

})();
//# sourceMappingURL=main.js.map
